webpackJsonp([1],{

/***/ 102:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var classesObject = {
  Eyes: function Eyes(firstEye, secondEye) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Eyes);

    this.firstEye = {
      x: firstEye.x,
      y: firstEye.y
    };
    this.secondEye = {
      x: secondEye.x,
      y: secondEye.y
    };
  },
  Mouth: function Mouth(leftMouthCorner, rightMouthCorner) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Mouth);

    this.leftMouthCorner = {
      x: leftMouthCorner.x,
      y: leftMouthCorner.y
    };
    this.rightMouthCorner = {
      x: rightMouthCorner.x,
      y: rightMouthCorner.y
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (classesObject);

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var geometryFunctions = {
  angleBetween2Lines: function angleBetween2Lines(A1, A2, B1, B2) {
    var angle1 = Math.atan2(A2.y - A1.y, A1.x - A2.x) * 180 / Math.PI;
    var angle2 = Math.atan2(B2.y - B1.y, B1.x - B2.x) * 180 / Math.PI;
    var calculatedAngle = angle1 - angle2;
    if (calculatedAngle < 0) calculatedAngle += 360;
    calculatedAngle = Math.floor(calculatedAngle);
    return calculatedAngle;
  },
  calculateScaleFactorByTwoLines: function calculateScaleFactorByTwoLines(A1, A2, B1, B2) {
    var lengthA = Math.sqrt(Math.pow(A2.x - A1.x, 2) + Math.pow(A2.y - A1.y, 2));
    var lengthB = Math.sqrt(Math.pow(B2.x - B1.x, 2) + Math.pow(B2.y - B1.y, 2));
    return lengthB / lengthA;
  },
  calculateScaleFactorOnPreview: function calculateScaleFactorOnPreview(A1, A2, B1, B2) {
    var lengthA = Math.sqrt(Math.pow(A2.x - A1.x, 2) + Math.pow(A2.y - A1.y, 2));
    var lengthB = Math.sqrt(Math.pow(B2.x - B1.x, 2) + Math.pow(B2.y - B1.y, 2));
    return lengthA / lengthB;
  },
  rotatePoint: function rotatePoint(x, y, cx, cy, rotationAngle) {
    var translatedAngle = 360 - rotationAngle;
    var radianAngle = translatedAngle * Math.PI / 180;
    var deltaX = x - cx;
    var deltaY = y - cy;
    var rotatedDeltaX = deltaY * Math.sin(radianAngle) + deltaX * Math.cos(radianAngle);
    var rotatedDeltaY = deltaY * Math.cos(radianAngle) - deltaX * Math.sin(radianAngle);
    return {
      x: rotatedDeltaX + cx,
      y: rotatedDeltaY + cy
    };
  },
  calculateScaleForControls: function calculateScaleForControls(scale, squareSideLength) {
    var scaledSize = squareSideLength * scale;
    var onePercent = scaledSize / 100;
    var controlScale = squareSideLength / onePercent / 100;
    return controlScale;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (geometryFunctions);

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var draggableService = {
  dragStart: function dragStart(event, index, draggableVariables, currentElemIndex) {
    draggableVariables.pointIndex = index;
    draggableVariables.selected = event.target;
    draggableVariables.offsetX = event.offsetX;
    draggableVariables.offsetY = event.offsetY;
    draggableVariables.currentElementIndex = currentElemIndex;
    draggableVariables.mouseX = event.target.parentNode.parentNode.offsetLeft;
    draggableVariables.mouseY = event.target.parentNode.parentNode.offsetTop;

    draggableVariables.elemX = event.layerX;
    draggableVariables.elemY = event.layerY;
    console.log('event ', event);
  },
  move: function move(event, draggableVariables, arrayIndex, story, refs, pointsFlag, containerWidthAndHeight) {
    var leftMouseIndentation = event.pageX - draggableVariables.mouseX - draggableVariables.elemX;
    var topMouseIndentation = event.pageY - draggableVariables.mouseY - draggableVariables.elemY;

    var xPoint = null;
    var yPoint = null;
    var positionY = null;
    var positionX = null;
    var stampPosition = null;
    var pointPosition = {};
    var staticPoints = {};

    draggableVariables.selected.style.left = leftMouseIndentation + 'px';
    draggableVariables.selected.style.top = topMouseIndentation + 'px';

    xPoint = parseInt(draggableVariables.selected.style.left.replace('px', ''), 10) + draggableVariables.selected.offsetWidth / 2;
    yPoint = parseInt(draggableVariables.selected.style.top.replace('px', ''), 10) + draggableVariables.selected.offsetHeight / 2;

    if (yPoint <= containerWidthAndHeight.height / 4) {
      positionY = 't';
    } else if (yPoint > containerWidthAndHeight.height / 4 && yPoint <= containerWidthAndHeight.height * 0.75) {
      positionY = 'm';
    } else if (yPoint > containerWidthAndHeight.height * 0.75) {
      positionY = 'b';
    }

    if (xPoint <= containerWidthAndHeight.width / 4) {
      positionX = 'l';
    } else if (xPoint > containerWidthAndHeight.width / 4 && xPoint <= containerWidthAndHeight.width * 0.75) {
      positionX = 'c';
    } else if (xPoint > containerWidthAndHeight.width * 0.75) {
      positionX = 'r';
    }
    stampPosition = positionY + positionX;

    if (positionX === 'l') {
      pointPosition.x = 0;
    } else if (positionX === 'c') {
      pointPosition.x = containerWidthAndHeight.width / 2;
    } else if (positionX === 'r') {
      pointPosition.x = containerWidthAndHeight.width;
    }
    if (positionY === 't') {
      pointPosition.y = 0;
    } else if (positionY === 'm') {
      pointPosition.y = containerWidthAndHeight.height / 2;
    } else if (positionY === 'b') {
      pointPosition.y = containerWidthAndHeight.height;
    }

    if (draggableVariables.elemX + draggableVariables.selected.offsetLeft >= containerWidthAndHeight.width) {
      draggableVariables.selected.style.left = containerWidthAndHeight.width - draggableVariables.elemX + 'px';
      console.error('too much');
    } else if (draggableVariables.elemX + draggableVariables.selected.offsetLeft <= 0) {
      draggableVariables.selected.style.left = -draggableVariables.elemX + 'px';
      console.warn('too few');
    }
    if (draggableVariables.elemY + draggableVariables.selected.offsetTop >= containerWidthAndHeight.height) {
      draggableVariables.selected.style.top = containerWidthAndHeight.height - draggableVariables.elemY + 'px';
      console.error('too much');
    } else if (draggableVariables.elemY + draggableVariables.selected.offsetTop <= 0) {
      draggableVariables.selected.style.top = -draggableVariables.elemY + 'px';
      console.warn('too few');
    }

    staticPoints.x = pointPosition.x - draggableVariables.selected.offsetLeft;

    staticPoints.y = pointPosition.y - draggableVariables.selected.offsetTop;

    if (story.data.content[arrayIndex]) {
      story.data.content[arrayIndex].points[draggableVariables.pointIndex] = {
        x: staticPoints.x * (4 / 3),
        y: staticPoints.y * (4 / 3)
      };
      story.data.content[arrayIndex].position = stampPosition;
      story.data.content[arrayIndex].staticOffset = {
        x: parseInt(draggableVariables.selected.style.left.replace('px', ''), 10),
        y: parseInt(draggableVariables.selected.style.top.replace('px', ''), 10)
      };
    }
  },
  dragDestroy: function dragDestroy(draggableVariables) {
    draggableVariables.selected = null;
  },
  dragStartScaleResize: function dragStartScaleResize(event, index, scaleResizeVariables, currentElemIndex, container) {
    scaleResizeVariables.pointIndex = index;
    scaleResizeVariables.offsetX = event.offsetX;
    scaleResizeVariables.offsetY = event.offsetY;
    scaleResizeVariables.currentElementIndex = currentElemIndex;
    scaleResizeVariables.selected = event.target;
    scaleResizeVariables.mouseX = event.target.parentNode.offsetLeft;
    scaleResizeVariables.mouseY = event.target.parentNode.offsetTop;
    scaleResizeVariables.containerX = container.offsetLeft;
    scaleResizeVariables.containerY = container.offsetTop;

    scaleResizeVariables.elemX = event.offsetX;
    scaleResizeVariables.elemY = event.offsetY;
  },
  moveScaleResize: function moveScaleResize(event, scaleResizeVariables) {
    var leftMouseIndentation = event.pageX - scaleResizeVariables.mouseX - scaleResizeVariables.containerX - scaleResizeVariables.elemX;
    var topMouseIndentation = event.pageY - scaleResizeVariables.mouseY - scaleResizeVariables.containerY - scaleResizeVariables.elemY;
    var xPoint = null;
    var yPoint = null;

    xPoint = leftMouseIndentation + scaleResizeVariables.selected.offsetWidth / 2;
    yPoint = topMouseIndentation + scaleResizeVariables.selected.offsetHeight / 2;
    scaleResizeVariables.xPoint = xPoint;
    scaleResizeVariables.yPoint = yPoint;
  },
  moveEyesLips: function moveEyesLips(event, draggableVariables, stampIndex, story, refs, pointsFlag, containerWidthAndHeight) {
    var leftMouseIndentation = event.pageX - draggableVariables.mouseX - draggableVariables.elemX;
    var topMouseIndentation = event.pageY - draggableVariables.mouseY - draggableVariables.elemY;

    draggableVariables.selected.style.left = leftMouseIndentation + 'px';
    draggableVariables.selected.style.top = topMouseIndentation + 'px';
    draggableVariables.pivot_id = story.data.content[stampIndex].pivot_id;

    if (draggableVariables.elemX + draggableVariables.selected.offsetLeft >= containerWidthAndHeight.width) {
      draggableVariables.selected.style.left = containerWidthAndHeight.width - draggableVariables.elemX + 'px';
      console.error('too much');
    } else if (draggableVariables.elemX + draggableVariables.selected.offsetLeft <= 0) {
      draggableVariables.selected.style.left = -draggableVariables.elemX + 'px';
      console.warn('too few');
    }

    if (draggableVariables.elemY + draggableVariables.selected.offsetTop >= containerWidthAndHeight.height) {
      draggableVariables.selected.style.top = containerWidthAndHeight.height - draggableVariables.elemY + 'px';
      console.error('too much');
    } else if (draggableVariables.elemY + draggableVariables.selected.offsetTop <= 0) {
      draggableVariables.selected.style.top = -draggableVariables.elemY + 'px';
      console.warn('too few');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (draggableService);

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports) {



(function (view) {
  "use strict";

  var Uint8Array = view.Uint8Array,
      HTMLCanvasElement = view.HTMLCanvasElement,
      canvas_proto = HTMLCanvasElement && HTMLCanvasElement.prototype,
      is_base64_regex = /\s*;\s*base64\s*(?:;|$)/i,
      to_data_url = "toDataURL",
      base64_ranks,
      decode_base64 = function decode_base64(base64) {
    var len = base64.length,
        buffer = new Uint8Array(len / 4 * 3 | 0),
        i = 0,
        outptr = 0,
        last = [0, 0],
        state = 0,
        save = 0,
        rank,
        code,
        undef;
    while (len--) {
      code = base64.charCodeAt(i++);
      rank = base64_ranks[code - 43];
      if (rank !== 255 && rank !== undef) {
        last[1] = last[0];
        last[0] = code;
        save = save << 6 | rank;
        state++;
        if (state === 4) {
          buffer[outptr++] = save >>> 16;
          if (last[1] !== 61) {
              buffer[outptr++] = save >>> 8;
            }
          if (last[0] !== 61) {
              buffer[outptr++] = save;
            }
          state = 0;
        }
      }
    }

    return buffer;
  };
  if (Uint8Array) {
    base64_ranks = new Uint8Array([62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 0, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51]);
  }
  if (HTMLCanvasElement && (!canvas_proto.toBlob || !canvas_proto.toBlobHD)) {
    if (!canvas_proto.toBlob) canvas_proto.toBlob = function (callback, type) {
      if (!type) {
        type = "image/png";
      }
      if (this.mozGetAsFile) {
        callback(this.mozGetAsFile("canvas", type));
        return;
      }
      if (this.msToBlob && /^\s*image\/png\s*(?:$|;)/i.test(type)) {
        callback(this.msToBlob());
        return;
      }

      var args = Array.prototype.slice.call(arguments, 1),
          dataURI = this[to_data_url].apply(this, args),
          header_end = dataURI.indexOf(","),
          data = dataURI.substring(header_end + 1),
          is_base64 = is_base64_regex.test(dataURI.substring(0, header_end)),
          blob;
      if (Blob.fake) {
        blob = new Blob();
        if (is_base64) {
          blob.encoding = "base64";
        } else {
          blob.encoding = "URI";
        }
        blob.data = data;
        blob.size = data.length;
      } else if (Uint8Array) {
        if (is_base64) {
          blob = new Blob([decode_base64(data)], { type: type });
        } else {
          blob = new Blob([decodeURIComponent(data)], { type: type });
        }
      }
      callback(blob);
    };

    if (!canvas_proto.toBlobHD && canvas_proto.toDataURLHD) {
      canvas_proto.toBlobHD = function () {
        to_data_url = "toDataURLHD";
        var blob = this.toBlob();
        to_data_url = "toDataURL";
        return blob;
      };
    } else {
      canvas_proto.toBlobHD = canvas_proto.toBlob;
    }
  }
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this);

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates_story_editor_component_html__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates_story_editor_component_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__templates_story_editor_component_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_story_editor_component_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_story_editor_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_story_editor_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visual_editor_stamps_list_component__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__preview_services__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visual_preview_component__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visual_preview_square_compontent__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__droppable_zone__ = __webpack_require__(44);












__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('story-editor', {
  template: __WEBPACK_IMPORTED_MODULE_4__templates_story_editor_component_html___default.a,
  components: {
    StampListComponent: __WEBPACK_IMPORTED_MODULE_6__visual_editor_stamps_list_component__["a" /* default */],
    PreviewComponent: __WEBPACK_IMPORTED_MODULE_8__visual_preview_component__["a" /* default */],
    PreviewSquareComponent: __WEBPACK_IMPORTED_MODULE_9__visual_preview_square_compontent__["a" /* default */],
    DropZone: __WEBPACK_IMPORTED_MODULE_10__droppable_zone__["a" /* default */]
  },
  props: {
    story: {
      type: Object,
      required: true
    },
    photoUrl: {
      type: String,
      required: true
    },
    size: {
      type: Object,
      required: true
    },
    faceLandmarks: {
      type: Object,
      required: true
    },
    host: {
      default: 'http://work.stk.908.vc'
    },
    squarePhotoUrl: {
      type: String,
      required: true
    },
    squareSize: {
      type: Object,
      required: true
    },
    squareFaceLandmarks: {
      type: Object,
      required: true
    },
    usage: {
      type: String
    }
  },
  data: function data() {
    return {
      verticalLoadStart: false,
      squareLoadStart: false,
      stampIndex: null,
      parsedStory: this.story,
      square: false,
      packsQuery: '',
      storyId: this.story.data.id,
      changedType: null,
      packsList: '',
      stampsList: '',
      changeShape: true,
      pivotId: '',
      showPacksTrigger: false,
      differentShapeIntendSquare: {},
      differentShapeIntendVertical: {},
      squareSettings: null,
      verticalSettings: null,
      staticStampChanges: null,
      demoUrl: 'https://m.me/1532404563448549?ref=',
      refreshComponents: true,
      framePositionTrigger: true,
      commonPack: [],
      loader: null,
      photoArray: [{
        title: 'lisa',
        vertical: {
          faceLandmarks: {
            eyes: [{ x: 58.6, y: 165.9 }, { x: 160.3, y: 166 }],
            mouth: [{ x: 63.5, y: 287.5 }, { x: 146.75, y: 288.35 }],
            nose: {
              x: 97.5,
              y: 167
            }
          },
          url: '/stories/lisa_vertical.png'
        },
        square: {
          faceLandmarks: {
            eyes: [{ x: 163.6, y: 165.9 }, { x: 265.3, y: 166 }],
            mouth: [{ x: 168.5, y: 287.5 }, { x: 251.75, y: 288.35 }],
            nose: {
              x: 202.5,
              y: 167
            }
          },
          url: '/stories/lisa_square.png'
        }
      }, {
        title: 'monroe',
        vertical: {
          faceLandmarks: {
            eyes: [{ x: 102, y: 136.3 }, { x: 186.3, y: 160 }],
            mouth: [{ x: 88, y: 216 }, { x: 157, y: 234.8 }],
            nose: {
              x: 141,
              y: 147
            }
          },

          url: '/stories/monroe_vertical.png'
        },
        square: {
          faceLandmarks: {
            eyes: [{ x: 201.3, y: 126.6 }, { x: 304.9, y: 156.4 }],
            mouth: [{ x: 186.7, y: 224.4 }, { x: 265.7, y: 248.3 }],
            nose: {
              x: 248,
              y: 143
            }
          },

          url: '/stories/monroe_square.png'
        }
      }, {
        title: 'leonardo',
        vertical: {
          faceLandmarks: {
            eyes: [{ x: 52, y: 81.7 }, { x: 157, y: 92.2 }],
            mouth: [{ x: 45, y: 209 }, { x: 122, y: 217 }],
            nose: {
              x: 82,
              y: 85
            }
          },

          url: '/stories/leonardo_vertical.png'
        },
        square: {
          faceLandmarks: {
            eyes: [{ x: 157, y: 81.7 }, { x: 262, y: 92.2 }],
            mouth: [{ x: 150, y: 209 }, { x: 227, y: 217 }],
            nose: {
              x: 187,
              y: 85
            }
          },

          url: '/stories/leonardo_square.png'
        }
      }],
      currentPhotoIndex: 0,
      currentPhoto: {
        vertical: {
          url: ''
        },
        square: {
          url: ''
        }
      }
    };
  },

  methods: {
    typeTrigger: function typeTrigger(obj) {
      this.changedType = obj;
      console.log('type obj ', obj);
    },
    updateComponents: function updateComponents() {
      this.refreshComponents = !this.refreshComponents;
    },
    setStampIndex: function setStampIndex(index) {
      if (index === 0) {
        this.stampIndex = '0';
      } else {
        this.stampIndex = index;
      }
      console.log('this.stampIndex ', this.stampIndex);
    },
    changeStoryShape: function changeStoryShape() {
      this.square = !this.square;
      this.updateStoryShape();
    },
    setNewCurrentPhoto: function setNewCurrentPhoto() {
      this.currentPhoto = this.photoArray[this.currentPhotoIndex];
      this.updateComponents();
    },
    nextPhoto: function nextPhoto() {
      if (this.photoArray.length - 1 === this.currentPhotoIndex) {
        this.currentPhotoIndex = 0;
      } else {
        this.currentPhotoIndex = this.currentPhotoIndex + 1;
      }
      this.setNewCurrentPhoto();
    },
    prevPhoto: function prevPhoto() {
      if (this.currentPhotoIndex === 0) {
        this.currentPhotoIndex = this.photoArray.length - 1;
      } else {
        this.currentPhotoIndex = this.currentPhotoIndex - 1;
      }
      this.setNewCurrentPhoto();
    },
    getStampObj: function getStampObj(obj) {
      this.parsedStory = obj;
    },
    updateStoryShape: function updateStoryShape() {
      this.changeShape = !this.changeShape;
    },

    myDebounce: __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.debounce(function (params, func) {
      func(params);
    }, 300),

    getPacks: function getPacks() {
      var that = this;

      that.$http.get(that.host + '/cp/packs/ajax/titles', {}).then(function (success) {
        console.log('success ', success);
        that.packsList = success.body.packs;
        that.stampsList = '';
        that.getCommonPackContent(that.packsList);
      }, function (error) {
        console.log('error ', error);
      });
    },
    getCommonPackContent: function getCommonPackContent(packList) {
      var that = this;
      packList.forEach(function (item) {
        if (item.title.toLowerCase() === 'common') {
          that.$http.get(that.host + '/cp/packs/ajax/content', {
            params: {
              pack_id: item.id
            }
          }).then(function (success) {
            that.commonPack = success.body.content;
          }, function (error) {});
        }
      });
    },
    getStampsFromServer: function getStampsFromServer(id) {
      var _this = this;

      this.$http.get(this.host + '/cp/packs/ajax/content', {
        params: {
          pack_id: id
        }
      }).then(function (success) {
        console.log('success ', success);
        _this.stampsList = success.body.content;
        _this.showPacksTrigger = false;
      }, function (error) {
        console.log('error ', error);
      });
    },
    addStampToStoryArray: function addStampToStoryArray(stampId, storyId) {
      var that = this;
      var loaderStatus = true;
      __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, loaderStatus);
      that.$http.post(that.host + '/cp/stories/' + storyId + '/content', { id: stampId }).then(function (success) {
        console.log('new stamp added ', success);

        that.parsedStory.data.content.push(success.body.content);
        console.warn('new stamp ', success.body.content);
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        that.updateComponents();
      }, function (error) {
        console.error('error ', error);
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
      });
    },
    deleteAndReload: function deleteAndReload(story, stamp) {
      this.stampIndex = null;
      this.updateStampHttp();
    },
    demoInMessenger: function demoInMessenger(e) {
      this.updateStampHttp().then(function (success) {
        console.log('success ', success);
      }, function (error) {
        console.log('error ', error);
      });
    },
    sortByOrder: function sortByOrder(a, b) {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    },
    sortArrayWithoutMutating: function sortArrayWithoutMutating(arr) {
      return arr.concat().sort(this.sortByOrder);
    },
    sortArrayByType: function sortArrayByType(storyContent) {
      var typeFrameArr = [];
      var elseTypesArr = [];
      storyContent.forEach(function (stamp) {
        if (stamp.type === 'frame') {
          typeFrameArr.push(stamp);
        } else {
          elseTypesArr.push(stamp);
        }
      });
      return typeFrameArr.concat(elseTypesArr);
    },
    updateStampHttp: function updateStampHttp() {
      console.log('parsedStory.data.content ', this.parsedStory.data.content);
      var that = this;
      var promiseAllArray = [];
      var sortedArrayByOrder = void 0;
      var sortedByType = void 0;
      var loaderStatus = true;
      __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, loaderStatus);
      if (!window.VUEMAINSTK.$children[0].storyId) {
        that.storyId = that.parsedStory.data.id;
      }
      sortedArrayByOrder = this.sortArrayWithoutMutating(this.parsedStory.data.content);
      sortedByType = this.sortArrayByType(sortedArrayByOrder);
      sortedByType.forEach(function (item, i, arr) {
        item.order = i + 1;
        if (item.delta_rotation < 0) {
          item.delta_rotation += 360;
        }
        promiseAllArray.push(that.$http.put(that.host + '/cp/stories/' + that.storyId + '/content/' + item.pivot_id, {
          stamp: item,
          photo_type: that.photoType
        }));
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseAllArray).then(function (success) {
        console.log('success ', success);
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        that.updateComponents();
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        that.updateComponents();
        console.log('error ', error);
      });
    },
    framePositionChanged: function framePositionChanged() {
      this.framePositionTrigger = !this.framePositionTrigger;
    },
    getStaticStampChanges: function getStaticStampChanges(staticObject) {
      this.staticStampChanges = staticObject;
    },
    cancelStampSelecting: function cancelStampSelecting() {
      this.updateComponents();
      this.stampIndex = null;
    },
    stopClosingLists: function stopClosingLists(event) {
      console.warn('stopClosingLists');
      event.stopPropagation();
    },
    cleanPacksAndStampsLists: function cleanPacksAndStampsLists() {
      this.stampsList = '';
      this.showPacksTrigger = false;
    },
    cleanPacksAndStampsListsEscape: function cleanPacksAndStampsListsEscape(e) {
      if (e.keyCode === 27) {
        this.packsQuery = '';
        this.stampsList = '';
        this.showPacksTrigger = false;
        console.log('this.stampsList ', this.stampsList);
      }
    },
    showPackList: function showPackList() {
      this.showPacksTrigger = true;
    },
    preloadImages: function preloadImages(photoArray) {
      var urlArray = [];
      photoArray.forEach(function (item) {
        urlArray.push(item.vertical.url);
        urlArray.push(item.square.url);
      });
      var preloadImages = [];
      for (var i = 0; i < urlArray.length; i += 1) {
        preloadImages[i] = new Image();
        preloadImages[i].src = urlArray[i];
      }
    },
    dropZoneUpdatedStory: function dropZoneUpdatedStory(story) {
      this.parsedStory = story;
      this.updateComponents();
    },
    updateCommonPack: function updateCommonPack(commonArray) {
      this.commonPack = commonArray;
    },
    updateLoader: function updateLoader(loaderStatus) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, loaderStatus);
    },
    removeStampFromStampsPack: function removeStampFromStampsPack(contentId, stampsPack) {
      for (var i = stampsPack.length - 1; i >= 0; i -= 1) {
        if (stampsPack[i].content_id === contentId) {
          stampsPack.splice(i, 1);
        }
      }
      return stampsPack;
    },
    deleteCommonStamp: function deleteCommonStamp(e, contentId, stamp) {
      var that = this;
      var loaderStatus = true;
      __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, loaderStatus);
      e.stopPropagation();
      if (that.usage === 'landing') {
        var stampIndex = that.story.data.content.indexOf(stamp);
        that.story.data.content.splice(stampIndex, 1);
        that.commonPack = that.removeStampFromStampsPack(contentId, that.commonPack);
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
      } else {
        that.$http.delete(that.host + '/cp/packs/stamp', {
          params: {
            content_id: contentId
          }
        }).then(function (success) {
          console.log('deleted ', success);
          that.commonPack = that.removeStampFromStampsPack(contentId, that.commonPack);
          __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        }, function (error) {
          console.log('not deleted ', error);
          __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        });
      }
    },
    propagateVerticalComponent: function propagateVerticalComponent() {
      this.verticalLoadStart = !this.verticalLoadStart;
    },
    propagateSquareComponent: function propagateSquareComponent() {
      this.squareLoadStart = !this.squareLoadStart;
    },
    beginSave: function beginSave() {
      var that = this;

      if (that.photoType === 'vertical') {
        that.propagateVerticalComponent();
      } else if (that.photoType === 'square') {
        that.propagateSquareComponent();
      }
    },
    generateSavedCanvas: function generateSavedCanvas(data) {
      var loaderStatus = true;
      var that = this;
      var canvas = that.$refs.canvasTest;
      var link = that.$refs.download;
      var photoUrl = void 0;
      var photoSize = void 0;
      if (that.photoType === 'vertical') {
        photoUrl = that.currentPhoto.vertical.url;
        photoSize = that.size;
      } else if (that.photoType === 'square') {
        photoUrl = that.currentPhoto.square.url;
        photoSize = that.squareSize;
      }
      console.log(data);
      console.log(photoSize);
      __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, loaderStatus);
      __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].createCanvasStory(canvas, photoUrl, photoSize, data.size, data.stamps, link).then(function (success) {
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        console.log('success ', success);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_7__preview_services__["a" /* default */].loaderService(that.loader, !loaderStatus);
        console.log('error ', error);
      });
    },
    addUserImagesToPhotoArray: function addUserImagesToPhotoArray(photoUrl, squarePhotoUrl, faceLandmarks, squareFaceLandmarks, photoArray, currentPhotoIndex) {
      var currentPhoto = void 0;
      if (photoUrl && squarePhotoUrl) {
        console.log('that.photoUrl ', photoUrl);
        var middleWareArray = [];
        middleWareArray.push({
          vertical: {
            faceLandmarks: faceLandmarks,
            url: photoUrl
          },
          square: {
            faceLandmarks: squareFaceLandmarks,
            url: squarePhotoUrl
          }
        });
        photoArray = middleWareArray.concat(photoArray);
        currentPhoto = photoArray[currentPhotoIndex];
      } else {
        currentPhoto = photoArray[currentPhotoIndex];
      }
      return { currentPhoto: currentPhoto, photoArray: photoArray };
    }
  },
  computed: {
    photoType: function photoType() {
      return this.square ? 'square' : 'vertical';
    },
    filteredPacks: function filteredPacks() {
      var _this2 = this;

      var result = this.packsList;
      if (result && this.packsQuery.trim() !== '') {
        result = result.filter(function (item) {
          return item.title.toLowerCase().includes(_this2.packsQuery.toLowerCase());
        });
      }
      return result;
    }
  },
  destroyed: function destroyed() {
    var that = this;
    window.removeEventListener('click', that.cleanPacksAndStampsLists);
    window.removeEventListener('keyup', that.cleanPacksAndStampsListsEscape);
  },
  mounted: function mounted() {
    var that = this;
    that.loader = document.getElementsByClassName('loader')[0];
    var imagesArray = that.addUserImagesToPhotoArray(that.photoUrl, that.squarePhotoUrl, that.faceLandmarks, that.squareFaceLandmarks, that.photoArray, that.currentPhotoIndex);
    that.currentPhoto = imagesArray.currentPhoto;
    that.photoArray = imagesArray.photoArray;
    this.getPacks();
    console.log('this.currentPhoto ', this.currentPhoto);

    window.addEventListener('click', that.cleanPacksAndStampsLists);
    window.addEventListener('keyup', that.cleanPacksAndStampsListsEscape);
    that.preloadImages(that.photoArray);
  }
}));

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_droppable_zone_html__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates_droppable_zone_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__templates_droppable_zone_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_droppable_zone_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_droppable_zone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_droppable_zone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_preview_services__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dropzone', {
  template: __WEBPACK_IMPORTED_MODULE_1__templates_droppable_zone_html___default.a,
  props: ['story', 'commonPack', 'host', 'storyId'],
  data: function data() {
    return {
      hello: 'hello',
      uploadedPhoto: []
    };
  },

  methods: {},
  mounted: function mounted() {
    var that = this;
    var loaderActive = true;
    window.addEventListener('load', function () {
      that.$refs.dropzone.addEventListener('dragover', function (e) {
        e.preventDefault();
        that.$refs.dropzone.style.background = 'rgba(220, 220, 220, 0.26)';
      });
      that.$refs.dropzone.addEventListener('dragenter', function (e) {
        e.preventDefault();
      });
      that.$refs.dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        var dataTransfer = e.dataTransfer;
        var files = dataTransfer.files;
        var fileType = 'File';
        for (var key in files) {
          if (Object.prototype.toString.call(files[key]).indexOf(fileType) !== -1) {
            if (files && files[key].type && files[key].type.match('image.*')) {
              that.$emit('update-loader', loaderActive);
              var data = new FormData();
              data.append('image', files[key]);
              var saveBackendResult = __WEBPACK_IMPORTED_MODULE_3__js_preview_services__["a" /* default */].sendPhotoToBackend(that.$http, that.host, that.storyId, data);
              saveBackendResult.then(function (success) {
                that.story.data.content.push(success.body.content);
                that.$emit('updated-story', that.story);
                that.commonPack.push(success.body.content);
                that.$emit('update-common', that.commonPack);
                that.$emit('update-loader', !loaderActive);
              }, function (error) {
                console.warn('Error message: ' + error.statusText + ' ', error);
                that.$emit('update-loader', !loaderActive);
              });
            }
          }
        }
      });
    });

    window.addEventListener('drop', function (e) {
      e.preventDefault();
      that.$refs.dropzone.style.border = '3px dashed #c8c8c8';
      that.$refs.dropzone.style.background = 'transparent';
    });
    window.addEventListener('dragleave', function (e) {
      e.preventDefault();
      that.$refs.dropzone.style.border = '3px dashed #c8c8c8';
      that.$refs.dropzone.style.background = 'transparent';
    });
    window.addEventListener('dragover', function (e) {
      e.preventDefault();
      that.$refs.dropzone.style.border = '3px dashed #3bd639';
    });
  }
}));

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert_dist_sweetalert_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert_dist_sweetalert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert_dist_sweetalert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_visual_editor_stamps_list_html__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates_visual_editor_stamps_list_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__templates_visual_editor_stamps_list_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_visual_editor_stamps_list_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_visual_editor_stamps_list_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_visual_editor_stamps_list_css__);






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('visual-stamps-list', {
  template: __WEBPACK_IMPORTED_MODULE_3__templates_visual_editor_stamps_list_html___default.a,
  props: ['story', 'hostUrl', 'stampIndex', 'storyId'],
  data: function data() {
    return {
      positions: {
        frame: [{ name: 'bottom', value: 'b' }, { name: 'top', value: 't' }],
        static: [{
          name: 'top left',
          value: 'tl'
        }, {
          name: 'top center',
          value: 'tc'
        }, {
          name: 'top right',
          value: 'tr'
        }, {
          name: 'middle left',
          value: 'ml'
        }, {
          name: 'middle center',
          value: 'mc'
        }, {
          name: 'middle right',
          value: 'mr'
        }, {
          name: 'bottom left',
          value: 'bl'
        }, {
          name: 'bottom center',
          value: 'bc'
        }, {
          name: 'bottom right',
          value: 'br'
        }],
        eyes: [],
        mouth: []
      },
      stampTypes: ['eyes', 'mouth', 'static', 'frame']
    };
  },

  methods: {
    typeChanges: function typeChanges(story, index, type, currStamp) {
      var changedTypeStamp = {};
      if (type === 'static') {
        story.data.content[index].points[0] = { x: 0, y: 0 };
        story.data.content[index].position = 'tl';
        story.data.content[index].scale = 1;
        story.data.content[index].rotation = 0;
      } else {
        story.data.content[index].points[0] = { x: 60, y: 0 };
        story.data.content[index].position = 't';
      }
      changedTypeStamp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(changedTypeStamp, story.data.content[index]);
      this.$emit('story-update', story);
      this.$emit('type-trigger', changedTypeStamp);
      this.$emit('stamp-index', index);
      console.log('changedTypeStamp ', changedTypeStamp);
    },
    deleteStamp: function deleteStamp(pivotId, stamp) {
      var _this = this;

      console.log('delete stamp function');
      var that = this;
      var loader = document.getElementsByClassName('loader')[0];
      var stampIndex = that.story.data.content.indexOf(stamp);
      loader.style.display = 'block';
      var deleteState = confirm('Do you want to delete this stamp?');
      if (deleteState) {
        that.story.data.content.splice(stampIndex, 1);
        that.$http.delete(that.hostUrl + '/cp/stories/' + that.storyId + '/content/' + pivotId).then(function (success) {
          console.log('success ', success);
          loader.style.display = 'none';
          _this.$emit('delete', that.story, stamp);
        }, function (error) {
          console.warn('error ', error);
          loader.style.display = 'none';
        });
      } else {
        loader.style.display = 'none';
      }
    },
    emitFramePosition: function emitFramePosition(position) {
      console.warn(this.currentStamp.position);
      console.warn(position);
      this.$emit('frame-position');
    },
    backspaceDeleteButton: function backspaceDeleteButton(e) {
      var that = this;
      if (e.keyCode === 8 || e.keyCode === 46) {
        that.deleteStamp(that.currentStamp.pivot_id, that.currentStamp);
      }
    }
  },
  computed: {
    currentStamp: function currentStamp() {
      return this.story.data.content[this.stampIndex];
    },
    currentScale: function currentScale() {
      return this.story.data.content[this.stampIndex].scale.toFixed(2);
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.backspaceDeleteButton);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.backspaceDeleteButton);
  }
}));

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_visual_preview_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_visual_preview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_visual_preview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_visual_preview_html__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_visual_preview_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__templates_visual_preview_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable_service__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geometry__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__preview_services__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('visualPreview', {
  template: __WEBPACK_IMPORTED_MODULE_2__templates_visual_preview_html___default.a,
  props: {
    photoUrl: {
      default: 'http://stickerpipe.com/static/img/ema.0158668.png'
    },
    startDownload: {
      required: true
    },
    size: {
      default: function _default() {
        return {
          width: 360,
          height: 640
        };
      }
    },
    faceLandmarks: {
      required: true,
      default: function _default() {
        return {
          eyes: [{ x: 121, y: 230 }, { x: 245, y: 232 }],
          mouth: [{ x: 162, y: 302 }, { x: 237, y: 297 }]
        };
      }
    },
    changeShape: {
      required: true
    },
    story: {
      required: true
    },
    changedType: {
      required: true
    },
    photoType: {
      required: true
    },
    photoTypeTrigger: {
      required: true
    },
    staticStampChanges: {
      required: true
    },
    refreshComponents: {
      required: true
    },
    framePositionChanged: {
      required: true
    },
    usage: {
      required: true
    }
  },
  data: function data() {
    return {
      imageDensity: 'xxhdpi',
      eyesAndLipsMiddleware: {},
      middlewareIndex: null,
      scaleResizeAvailableIndex: null,
      scaleRotateEyesLipsControl: {},
      computedStamps: [],
      photoHeightAndWidth: {},
      draggableVariables: {
        selected: '',
        mouseX: '',
        mouseY: '',
        elemX: '',
        elemY: '',
        finalIndex: '',
        currentElementIndex: null
      },
      stampIndex: null,
      scaleResizeStaticControl: {
        selected: '',
        mouseX: '',
        mouseY: '',
        elemX: '',
        elemY: '',
        finalIndex: '',
        currentElementIndex: null
      },
      faceFromServer: {
        eyes: {},
        mouth: {}
      },
      crossSize: 14,
      currentStampType: null,
      stampsRangesXY: {
        minimumValue: 0,
        middleValue: 60,
        maximumValue: 120
      },
      controlSideLength: 20,
      initialStampSideLength: 120,
      eventX: null,
      eventY: null,
      eventSelectStamp: null,
      selectStampFirstLoad: false
    };
  },

  methods: {
    clickOnImage: function clickOnImage(event) {
      console.log('event ', event);
      this.scaleResizeAvailableIndex = null;
      this.currentStampType = null;
      this.eventSelectStamp = null;
      this.$emit('current-stamp-index', null);
    },
    startScaleResizeEyesLips: function startScaleResizeEyesLips(event, index, elem) {
      var _this = this;

      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStartScaleResize(event, null, this.scaleRotateEyesLipsControl, null, this.$refs.container);

      this.story.data.content.forEach(function (item, i, arr) {
        if (item.pivot_id === elem.pivot_id) {
          _this.stampIndex = i;
          _this.middlewareIndex = i;
        }
      });
      document.addEventListener('mousemove', this.moveScaleResizeEyesLips);
      document.onmouseup = this.dragDestroy;
    },
    moveScaleResizeEyesLips: function moveScaleResizeEyesLips(event) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].moveScaleResize(event, this.scaleRotateEyesLipsControl);
      var angleAndScale = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].scalingAndRotating(this.scaleRotateEyesLipsControl, this.stampsRangesXY);
      this.story.data.content[this.stampIndex].rotation = angleAndScale.angle;
      if (angleAndScale.scale < 0.4) {
        angleAndScale.scale = 0.4;
      }
      this.story.data.content[this.stampIndex].scale = angleAndScale.scale;
      if (this.story.data.content[this.stampIndex].initialCoordinatesVertical && !this.story.data.content[this.stampIndex].coordinates) {
        this.story.data.content[this.stampIndex].coordinates = this.story.data.content[this.stampIndex].initialCoordinatesVertical;
      }
      var deltaRotation = angleAndScale.angle - this.story.data.content[this.stampIndex].initialRotationVertical;
      var deltaScale = angleAndScale.scale / this.story.data.content[this.stampIndex].initialScaleVertical;
      this.story.data.content[this.stampIndex].delta_scale = deltaScale;
      this.story.data.content[this.stampIndex].delta_rotation = deltaRotation;
      this.computedStamps.forEach(function (eyesStamp) {
        if (eyesStamp.pivot_id === that.story.data.content[that.stampIndex].pivot_id) {
          eyesStamp.scale = angleAndScale.scale;
          eyesStamp.rotate = -angleAndScale.angle;
          eyesStamp.controlScale = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].calculateScaleForControls(angleAndScale.scale, that.controlSideLength);
        }
      });
      this.story.data.content[this.stampIndex].workingPreview = this.photoType;
    },
    startScaleResize: function startScaleResize(event, index, elem) {
      var _this2 = this;

      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStartScaleResize(event, null, this.scaleResizeStaticControl, null, this.$refs.container);

      this.story.data.content.forEach(function (item, i, arr) {
        if (item.pivot_id === elem.pivot_id) {
          _this2.stampIndex = i;
        }
      });

      document.addEventListener('mousemove', this.moveScaleResize);
      document.onmouseup = this.dragDestroy;
    },
    moveScaleResize: function moveScaleResize(event) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].moveScaleResize(event, this.scaleResizeStaticControl);
      var angleAndScale = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].scalingAndRotating(this.scaleResizeStaticControl, this.stampsRangesXY);
      this.story.data.content[this.stampIndex].rotation = -angleAndScale.angle;
      if (angleAndScale.scale < 0.4) {
        angleAndScale.scale = 0.4;
      }
      this.story.data.content[this.stampIndex].scale = angleAndScale.scale;
      that.computedStamps.forEach(function (staticStamp) {
        if (staticStamp.pivot_id === that.story.data.content[that.stampIndex].pivot_id) {
          that.story.data.content[that.stampIndex].rotation = -angleAndScale.angle;
          that.story.data.content[that.stampIndex].scale = angleAndScale.scale;
          staticStamp.scale = angleAndScale.scale;
          staticStamp.rotate = -angleAndScale.angle;
          staticStamp.controlScale = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].calculateScaleForControls(angleAndScale.scale, that.controlSideLength);
        }
      });
      that.$emit('static-stamp-changes', {
        rotate: -angleAndScale.angle,
        scale: angleAndScale.scale,
        pivot_id: that.story.data.content[that.stampIndex].pivot_id
      });
    },
    dragStartEyesLips: function dragStartEyesLips(e, index, elem, currentElemIndex) {
      var _this3 = this;

      var maxOrder = null;
      var currentOrder = null;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStart(e, index, this.draggableVariables, currentElemIndex);
      document.addEventListener('mousemove', this.moveEyesLips);
      document.onmouseup = this.dragDestroy;
      this.story.data.content.forEach(function (item, i) {
        if (item.pivot_id === elem.pivot_id) {
          _this3.stampIndex = i;
        }
        if (currentOrder === null) {
          currentOrder = elem.order;
        }
        if (item !== elem && item.order > currentOrder) {
          currentOrder = item.order;

          maxOrder = parseInt(currentOrder, 10) + 1;
        } else if (elem.order === currentOrder) {
          maxOrder = parseInt(currentOrder, 10);
        }
      });

      this.story.data.content[this.stampIndex].order = maxOrder;
      if (this.scaleResizeAvailableIndex) {
        this.eventSelectStamp = this.scaleResizeAvailableIndex;
      }
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampIndex].pivot_id;

      this.computedStamps.forEach(function (item) {
        if (item.pivot_id === _this3.story.data.content[_this3.stampIndex].pivot_id) {
          _this3.story.data.content[_this3.stampIndex].scale = item.scale;
          item.order = maxOrder;
          _this3.currentStampType = item.type;
        }
      });
      this.$emit('current-stamp-index', this.stampIndex);
      this.eventX = e.pageX;
      this.eventY = e.pageY;
    },
    moveEyesLips: function moveEyesLips(e) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].moveEyesLips(e, this.draggableVariables, this.stampIndex, this.story, this.$refs.stamp, false, this.photoHeightAndWidth);

      this.computedStamps.forEach(function (stamp, i) {
        if (stamp.pivot_id === that.draggableVariables.pivot_id) {
          that.computedStamps[i].leftTopStampPoint = {
            x: parseInt(that.draggableVariables.selected.style.left.replace('px', ''), 10),
            y: parseInt(that.draggableVariables.selected.style.top.replace('px', ''), 10)
          };
        }
      });
      var left = parseInt(this.draggableVariables.selected.style.left.replace('px', ''), 10);
      var top = parseInt(this.draggableVariables.selected.style.top.replace('px', ''), 10);
      this.story.data.content[this.stampIndex].coordinates = {
        x: left,
        y: top
      };
      var deltaOffset = {
        x: this.story.data.content[this.stampIndex].coordinates.x - this.story.data.content[this.stampIndex].initialCoordinatesVertical.x,
        y: this.story.data.content[this.stampIndex].coordinates.y - this.story.data.content[this.stampIndex].initialCoordinatesVertical.y
      };
      var stampCenterX = 0;
      var stampCenterY = 0;
      var rotatePoint = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].rotatePoint(deltaOffset.x, deltaOffset.y, stampCenterX, stampCenterY, this.story.data.content[this.stampIndex].initialRotationVertical);
      deltaOffset.x = rotatePoint.x * (4 / 3) / this.story.data.content[this.stampIndex].initialScaleVertical;
      deltaOffset.y = rotatePoint.y * (4 / 3) / this.story.data.content[this.stampIndex].initialScaleVertical;
      this.story.data.content[this.stampIndex].delta_offset = deltaOffset;
      this.story.data.content[this.stampIndex].workingPreview = this.photoType;
    },
    selectFrameStamp: function selectFrameStamp(index, elem) {
      var _this4 = this;

      this.story.data.content.forEach(function (item, i) {
        if (item.pivot_id === elem.pivot_id) {
          _this4.stampIndex = i;
          _this4.currentStampType = item.type;
        }
      });
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampIndex].pivot_id;
      this.$emit('current-stamp-index', this.stampIndex);
      console.log('stampIndex from preview', this.stampIndex);
    },
    dragStart: function dragStart(e, index, elem, currentElemIndex) {
      var _this5 = this;

      var that = this;
      var maxOrder = null;
      var currentOrder = null;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStart(e, index, this.draggableVariables, currentElemIndex);

      document.addEventListener('mousemove', this.move);
      document.onmouseup = this.dragDestroy;
      this.story.data.content.forEach(function (item, i) {
        if (item.pivot_id === elem.pivot_id) {
          _this5.stampIndex = i;
        }
        if (currentOrder === null) {
          currentOrder = elem.order;
        }
        if (item !== elem && item.order > currentOrder) {
          currentOrder = item.order;

          maxOrder = parseInt(currentOrder, 10) + 1;
        } else if (elem.order === currentOrder) {
          maxOrder = parseInt(currentOrder, 10);
        }
      });
      this.story.data.content[this.stampIndex].order = maxOrder;
      this.computedStamps.forEach(function (stampStatic, i, arr) {
        if (stampStatic.pivot_id === that.story.data.content[that.stampIndex].pivot_id) {
          stampStatic.order = maxOrder;
          that.currentStampType = stampStatic.type;
        }
      });
      if (this.scaleResizeAvailableIndex) {
        this.eventSelectStamp = this.scaleResizeAvailableIndex;
      }
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampIndex].pivot_id;
      this.$emit('current-stamp-index', this.stampIndex);
      this.eventX = e.pageX;
      this.eventY = e.pageY;
    },
    move: function move(e) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].move(e, this.draggableVariables, this.stampIndex, this.story, this.$refs.static, false, this.photoHeightAndWidth);
      this.computedStamps.forEach(function (stamp) {
        if (stamp.pivot_id === that.story.data.content[that.stampIndex].pivot_id) {
          stamp.staticOffset = that.story.data.content[that.stampIndex].staticOffset;
        }
      });
    },
    dragDestroy: function dragDestroy() {
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragDestroy(this.draggableVariables);
      document.removeEventListener('mousemove', this.move);
      document.removeEventListener('mousemove', this.moveScaleResize);
      document.removeEventListener('mousemove', this.moveEyesLips);
      document.removeEventListener('mousemove', this.moveScaleResizeEyesLips);
    },
    initialLoad: function initialLoad(stamps) {
      var that = this;
      that.computedStamps = [];
      stamps.forEach(function (stamp, i, stampArr) {
        if (stamp.type === 'eyes' || stamp.type === 'mouth') {
          console.log('stamp ', stamp);
          var returnedEyesLips = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(stamp, that.faceLandmarks, that.imageDensity);
          stamp.initialRotationVertical = returnedEyesLips.initialRotation;
          stamp.initialScaleVertical = returnedEyesLips.initialScale;
          stamp.initialCoordinatesVertical = returnedEyesLips.initialCoordinates;

          if (stamp.type === 'eyes' && that.usage === 'landing' && !that.selectStampFirstLoad && stamp.content_id === 11916) {
            console.warn('OKAY');
            var highlightStamp = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].highlightDefaultStamp(that.story, stamp);
            that.stampIndex = highlightStamp.stampIndex;
            that.scaleResizeAvailableIndex = highlightStamp.highLightIndex;
            that.currentStampType = 'eyes';
            that.$emit('current-stamp-index', that.stampIndex);
            that.selectStampFirstLoad = true;
          }
          that.addTransformationsToEyesAndLips(returnedEyesLips, stamp);

          if (returnedEyesLips) {
            stamp.scale = returnedEyesLips.scale;
            stamp.rotation = -returnedEyesLips.rotate;
            returnedEyesLips.controlScale = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].calculateScaleForControls(returnedEyesLips.scale, that.controlSideLength);
            that.computedStamps.push(returnedEyesLips);
          }
        } else if (stamp.type === 'static') {
          that.computedStamps.push(__WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].createStaticStamp(stamp, that.photoHeightAndWidth, that.controlSideLength, that.imageDensity));
        } else if (stamp.type === 'frame') {
          that.computedStamps.push(__WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].createFrameStamp(stamp, that.imageDensity));
        }
      });

      console.log(that.stampIndex);
    },
    getCoordinatesEyesLips: function getCoordinatesEyesLips(computedEyesLips) {
      return {
        x: computedEyesLips.leftTopStampPoint.x,
        y: computedEyesLips.leftTopStampPoint.y
      };
    },
    addTransformationsToEyesAndLips: function addTransformationsToEyesAndLips(eyesOrLips, storyStamp) {
      if (storyStamp.delta_offset) {
        var stampCenterX = 0;
        var stampCenterY = 0;
        var rotatePoint = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].rotatePoint(storyStamp.delta_offset.x, storyStamp.delta_offset.y, stampCenterX, stampCenterY, 360 - eyesOrLips.initialRotation);

        eyesOrLips.leftTopStampPoint.x += rotatePoint.x / (4 / 3) * eyesOrLips.initialScale;
        eyesOrLips.leftTopStampPoint.y += rotatePoint.y / (4 / 3) * eyesOrLips.initialScale;
      }
      if (storyStamp.delta_scale) {
        eyesOrLips.scale *= storyStamp.delta_scale;
      }
      if (storyStamp.delta_rotation) {
        eyesOrLips.rotate -= storyStamp.delta_rotation;
        if (Math.abs(eyesOrLips.rotate) >= 360) eyesOrLips.rotate += 360;
      }
    },
    preventDrag: function preventDrag(e) {
      e.preventDefault();
    },
    showDataForStack: function showDataForStack(event, stamp) {
      var returnedData = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].stampStackPopUp(event, stamp, this.eventSelectStamp, this.scaleResizeAvailableIndex, this.eventX, this.eventY, this.initialStampSideLength, this.computedStamps, this.currentStampType, this.story, this.stampIndex);
      this.scaleResizeAvailableIndex = returnedData.scaleResizeAvailableIndex;
      this.currentStampType = returnedData.currentStampType;
      this.$emit('current-stamp-index', returnedData.stampIndex);
    }
  },
  watch: {
    startDownload: {
      handler: function handler() {
        var that = this;
        console.log('that.computedStamps ', that.computedStamps);
        __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].createDownloadImageData(that, that.initialStampSideLength, that.computedStamps);
      }
    },
    staticStampChanges: {
      handler: function handler() {
        var that = this;
        that.story.data.content.forEach(function (storyStamp) {
          that.computedStamps.forEach(function (stamp, i, arr) {
            if (stamp.pivot_id === that.staticStampChanges.pivot_id && stamp.pivot_id === storyStamp.pivot_id) {
              stamp.scale = that.staticStampChanges.scale;
              stamp.rotate = -that.staticStampChanges.rotate;
              storyStamp.scale = that.staticStampChanges.scale;
              storyStamp.rotation = -that.staticStampChanges.rotate;
            }
          });
        });
      },

      deep: true
    },

    changedType: {
      handler: function handler() {
        if (this.changeShape) {
          var that = this;
          var stampNotExist = true;
          var computedEyesLips = that.computedStamps;
          if (that.changedType.type === 'eyes' || that.changedType.type === 'mouth') {
            if (computedEyesLips.length > 0) {
              for (var i = computedEyesLips.length - 1; i >= 0; i -= 1) {
                if (computedEyesLips[i].pivot_id === that.changedType.pivot_id) {
                  computedEyesLips.splice(i, 1);
                  var returnedEysAndLips = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
                  if (that.story.data.content && that.stampIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                    that.story.data.content[that.stampIndex].coordinates = that.getCoordinatesEyesLips(returnedEysAndLips);
                    that.story.data.content[that.stampIndex].initialCoordinatesVertical = that.getCoordinatesEyesLips(returnedEysAndLips);
                  }
                  computedEyesLips.push(returnedEysAndLips);
                  stampNotExist = false;
                } else if (i === computedEyesLips.length - 1 && stampNotExist) {
                  var _returnedEysAndLips = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
                  if (that.story.data.content && that.stampIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                    that.story.data.content[that.stampIndex].coordinates = that.getCoordinatesEyesLips(_returnedEysAndLips);
                    that.story.data.content[that.stampIndex].initialCoordinatesVertical = that.getCoordinatesEyesLips(_returnedEysAndLips);
                  }

                  computedEyesLips.push(_returnedEysAndLips);
                }
              }
            } else {
              var _returnedEysAndLips2 = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
              if (that.story.data.content && that.stampIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                that.story.data.content[that.stampIndex].coordinates = that.getCoordinatesEyesLips(_returnedEysAndLips2);
                that.story.data.content[that.stampIndex].initialCoordinatesVertical = that.getCoordinatesEyesLips(_returnedEysAndLips2);
              }
              computedEyesLips.push(_returnedEysAndLips2);
            }
          } else if (that.changedType.type === 'static' || that.changedType.type === 'frame') {
            for (var _i = computedEyesLips.length - 1; _i >= 0; _i -= 1) {
              if (computedEyesLips[_i].pivot_id && computedEyesLips[_i].pivot_id === that.changedType.pivot_id) {
                computedEyesLips.splice(_i, 1);
              }
            }
          }
          if (that.changedType.type === 'eyes') {
            that.currentStampType = 'eyes';
          } else if (that.changedType.type === 'mouth') {
            that.currentStampType = 'mouth';
          } else if (that.changedType.type === 'static') {
            that.currentStampType = 'static';
          } else if (that.changedType.type === 'frame') {
            that.currentStampType = 'frame';
          }
          that.story.data.content[that.stampIndex].delta_offset = null;
          that.story.data.content[that.stampIndex].delta_rotation = null;
          that.story.data.content[that.stampIndex].delta_scale = null;
        }

        this.initialLoad(this.story.data.content);
      }
    },

    framePositionChanged: {
      handler: function handler() {
        this.initialLoad(this.story.data.content);
      }
    },
    refreshComponents: {
      handler: function handler() {
        this.scaleResizeAvailableIndex = null;
        this.currentStampType = null;
        this.eventSelectStamp = null;
        this.initialLoad(this.story.data.content);
        this.faceFromServer = {
          eyes: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Eyes(this.faceLandmarks.eyes[0], this.faceLandmarks.eyes[1]),
          mouth: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Mouth(this.faceLandmarks.mouth[0], this.faceLandmarks.mouth[1])
        };
        console.log('refreshComponents finished ');
      }
    },

    changeShape: {
      handler: function handler() {
        this.photoHeightAndWidth.height = this.$refs.photo.style.height.replace('px', '');
        this.photoHeightAndWidth.width = this.$refs.photo.style.width.replace('px', '');
        this.initialLoad(this.story.data.content);
        this.faceFromServer = {
          eyes: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Eyes(this.faceLandmarks.eyes[0], this.faceLandmarks.eyes[1]),
          mouth: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Mouth(this.faceLandmarks.mouth[0], this.faceLandmarks.mouth[1])
        };
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    window.addEventListener('load', function () {
      _this6.photoHeightAndWidth.height = _this6.$refs.photo.style.height.replace('px', '');
      _this6.photoHeightAndWidth.width = _this6.$refs.photo.style.width.replace('px', '');
      _this6.initialLoad(_this6.story.data.content);
      _this6.faceFromServer = {
        eyes: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Eyes(_this6.faceLandmarks.eyes[0], _this6.faceLandmarks.eyes[1]),
        mouth: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Mouth(_this6.faceLandmarks.mouth[0], _this6.faceLandmarks.mouth[1])
      };
    });
  },
  destroy: function destroy() {
    window.removeEventListener('load', function () {});
  }
}));

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_visual_preview_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_visual_preview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_visual_preview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_visual_square_preview_html__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templates_visual_square_preview_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__templates_visual_square_preview_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable_service__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geometry__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__preview_services__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('visualPreviewSquare', {
  template: __WEBPACK_IMPORTED_MODULE_2__templates_visual_square_preview_html___default.a,
  props: {
    photoUrl: {
      default: 'http://stickerpipe.com/static/img/ema.0158668.png'
    },
    startDownload: {
      required: true
    },
    size: {
      default: function _default() {
        return {
          width: 360,
          height: 640
        };
      }
    },
    faceLandmarks: {
      default: function _default() {
        return {
          eyes: [{ x: 150, y: 197 }, { x: 254, y: 194 }],
          mouth: [{ x: 162, y: 302 }, { x: 237, y: 297 }]
        };
      }
    },
    changeShape: {
      required: true
    },
    story: {
      required: true
    },
    changedType: {
      required: true
    },
    photoType: {
      required: true
    },
    photoTypeTrigger: {
      required: true
    },
    staticStampChanges: {
      required: true
    },
    refreshComponents: {
      required: true
    },
    framePositionChanged: {
      required: true
    }
  },
  data: function data() {
    return {
      imageDensity: 'xxhdpi',
      eyesAndLipsMiddleware: {},
      middlewareIndex: null,
      scaleResizeAvailableIndex: null,
      scaleRotateEyesLipsControl: {},
      computedStamps: [],
      photoHeightAndWidth: {},
      draggableVariables: {
        selected: '',
        mouseX: '',
        mouseY: '',
        elemX: '',
        elemY: '',
        finalIndex: '',
        currentElementIndex: null
      },
      stampSquareIndex: null,
      scaleResizeStaticControl: {
        selected: '',
        mouseX: '',
        mouseY: '',
        elemX: '',
        elemY: '',
        finalIndex: '',
        currentElementIndex: null
      },
      faceFromServer: {
        eyes: {},
        mouth: {}
      },
      crossSize: 14,
      currentStampType: null,
      stampsRangesXY: {
        minimumValue: 0,
        middleValue: 60,
        maximumValue: 120
      },
      controlSideLength: 20,
      initialStampSideLength: 120,
      eventX: null,
      eventY: null,
      eventSelectStamp: null
    };
  },

  methods: {
    clickOnImage: function clickOnImage(event) {
      console.log('event ', event);
      this.scaleResizeAvailableIndex = null;
      this.currentStampType = null;
      this.eventSelectStamp = null;
      this.$emit('current-stamp-index', null);
    },
    startScaleResizeEyesLips: function startScaleResizeEyesLips(event, index, elem) {
      var _this = this;

      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStartScaleResize(event, null, this.scaleRotateEyesLipsControl, null, this.$refs.container);

      this.story.data.content.forEach(function (item, i, arr) {
        if (item.pivot_id === elem.pivot_id) {
          _this.stampSquareIndex = i;
          _this.middlewareIndex = i;
        }
      });
      document.addEventListener('mousemove', this.moveScaleResizeEyesLips);
      document.onmouseup = this.dragDestroy;
    },
    moveScaleResizeEyesLips: function moveScaleResizeEyesLips(event) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].moveScaleResize(event, this.scaleRotateEyesLipsControl);
      var angleAndScale = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].scalingAndRotating(this.scaleRotateEyesLipsControl, this.stampsRangesXY);
      this.story.data.content[this.stampSquareIndex].rotation = angleAndScale.angle;
      if (angleAndScale.scale < 0.4) {
        angleAndScale.scale = 0.4;
      }
      this.story.data.content[this.stampSquareIndex].scale = angleAndScale.scale;
      if (this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare && !this.story.data.content[this.stampSquareIndex].coordinates) {
        this.story.data.content[this.stampSquareIndex].coordinates = this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare;
      }
      var deltaRotation = angleAndScale.angle - this.story.data.content[this.stampSquareIndex].initialRotationSquare;
      var deltaScale = angleAndScale.scale / this.story.data.content[this.stampSquareIndex].initialScaleSquare;
      this.story.data.content[this.stampSquareIndex].delta_scale = deltaScale;
      this.story.data.content[this.stampSquareIndex].delta_rotation = deltaRotation;
      this.computedStamps.forEach(function (eyesStamp) {
        if (eyesStamp.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          eyesStamp.scale = angleAndScale.scale;
          eyesStamp.rotate = -angleAndScale.angle;
          eyesStamp.controlScale = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].calculateScaleForControls(angleAndScale.scale, that.controlSideLength);
        }
      });
      this.story.data.content[this.stampSquareIndex].workingPreview = this.photoType;
    },
    startScaleResize: function startScaleResize(event, index, elem) {
      var _this2 = this;

      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStartScaleResize(event, null, this.scaleResizeStaticControl, null, this.$refs.container);

      this.story.data.content.forEach(function (item, i, arr) {
        if (item.pivot_id === elem.pivot_id) {
          _this2.stampSquareIndex = i;
        }
      });

      document.addEventListener('mousemove', this.moveScaleResize);
      document.onmouseup = this.dragDestroy;
    },
    moveScaleResize: function moveScaleResize(event) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].moveScaleResize(event, this.scaleResizeStaticControl);
      var angleAndScale = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].scalingAndRotating(this.scaleResizeStaticControl, this.stampsRangesXY);
      this.story.data.content[this.stampSquareIndex].rotation = -angleAndScale.angle;
      if (angleAndScale.scale < 0.4) {
        angleAndScale.scale = 0.4;
      }
      this.story.data.content[this.stampSquareIndex].scale = angleAndScale.scale;
      that.computedStamps.forEach(function (staticStamp) {
        if (staticStamp.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          that.story.data.content[that.stampSquareIndex].rotation = -angleAndScale.angle;
          that.story.data.content[that.stampSquareIndex].scale = angleAndScale.scale;
          staticStamp.scale = angleAndScale.scale;
          staticStamp.rotate = -angleAndScale.angle;
          staticStamp.controlScale = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].calculateScaleForControls(angleAndScale.scale, that.controlSideLength);
        }
      });
      that.$emit('static-stamp-changes', {
        rotate: -angleAndScale.angle,
        scale: angleAndScale.scale,
        pivot_id: that.story.data.content[that.stampSquareIndex].pivot_id
      });
    },
    dragStartEyesLips: function dragStartEyesLips(e, index, elem, currentElemIndex) {
      var _this3 = this;

      var maxOrder = null;
      var currentOrder = null;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStart(e, index, this.draggableVariables, currentElemIndex);
      document.addEventListener('mousemove', this.moveEyesLips);
      document.onmouseup = this.dragDestroy;
      this.story.data.content.forEach(function (item, i) {
        if (item.pivot_id === elem.pivot_id) {
          _this3.stampSquareIndex = i;
        }
        if (currentOrder === null) {
          currentOrder = elem.order;
        }
        if (item !== elem && item.order > currentOrder) {
          currentOrder = item.order;

          maxOrder = parseInt(currentOrder, 10) + 1;
        } else if (elem.order === currentOrder) {
          maxOrder = parseInt(currentOrder, 10);
        }
      });

      this.story.data.content[this.stampSquareIndex].order = maxOrder;
      if (this.scaleResizeAvailableIndex) {
        this.eventSelectStamp = this.scaleResizeAvailableIndex;
      }
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampSquareIndex].pivot_id;

      this.computedStamps.forEach(function (item) {
        if (item.pivot_id === _this3.story.data.content[_this3.stampSquareIndex].pivot_id) {
          _this3.story.data.content[_this3.stampSquareIndex].scale = item.scale;
          item.order = maxOrder;
          _this3.currentStampType = item.type;
        }
      });
      this.$emit('current-stamp-index', this.stampSquareIndex);
      this.eventX = e.pageX;
      this.eventY = e.pageY;
    },
    moveEyesLips: function moveEyesLips(e) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].moveEyesLips(e, this.draggableVariables, this.stampSquareIndex, this.story, this.$refs.stamp, false, this.photoHeightAndWidth);

      this.computedStamps.forEach(function (stamp, i) {
        if (stamp.pivot_id === that.draggableVariables.pivot_id) {
          that.computedStamps[i].leftTopStampPoint = {
            x: parseInt(that.draggableVariables.selected.style.left.replace('px', ''), 10),
            y: parseInt(that.draggableVariables.selected.style.top.replace('px', ''), 10)
          };
        }
      });
      var left = parseInt(this.draggableVariables.selected.style.left.replace('px', ''), 10);
      var top = parseInt(this.draggableVariables.selected.style.top.replace('px', ''), 10);
      this.story.data.content[this.stampSquareIndex].coordinates = {
        x: left,
        y: top
      };
      var deltaOffset = {
        x: this.story.data.content[this.stampSquareIndex].coordinates.x - this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare.x,
        y: this.story.data.content[this.stampSquareIndex].coordinates.y - this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare.y
      };
      var stampCenterX = 0;
      var stampCenterY = 0;
      var rotatePoint = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].rotatePoint(deltaOffset.x, deltaOffset.y, stampCenterX, stampCenterY, this.story.data.content[this.stampSquareIndex].initialRotationSquare);
      deltaOffset.x = rotatePoint.x * (4 / 3) / this.story.data.content[this.stampSquareIndex].initialScaleSquare;
      deltaOffset.y = rotatePoint.y * (4 / 3) / this.story.data.content[this.stampSquareIndex].initialScaleSquare;
      this.story.data.content[this.stampSquareIndex].delta_offset = deltaOffset;
      this.story.data.content[this.stampSquareIndex].workingPreview = this.photoType;
    },
    selectFrameStamp: function selectFrameStamp(index, elem) {
      var _this4 = this;

      this.story.data.content.forEach(function (item, i) {
        if (item.pivot_id === elem.pivot_id) {
          _this4.stampSquareIndex = i;
          _this4.currentStampType = item.type;
        }
      });
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampSquareIndex].pivot_id;
      this.$emit('current-stamp-index', this.stampSquareIndex);
      console.log('stampSquareIndex from preview', this.stampSquareIndex);
    },
    dragStart: function dragStart(e, index, elem, currentElemIndex) {
      var _this5 = this;

      var that = this;
      var maxOrder = null;
      var currentOrder = null;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragStart(e, index, this.draggableVariables, currentElemIndex);
      console.log('this draggableVariables ', this.draggableVariables);
      document.addEventListener('mousemove', this.move);
      document.onmouseup = this.dragDestroy;
      this.story.data.content.forEach(function (item, i) {
        if (item.pivot_id === elem.pivot_id) {
          _this5.stampSquareIndex = i;
        }
        if (currentOrder === null) {
          currentOrder = elem.order;
        }
        if (item !== elem && item.order > currentOrder) {
          currentOrder = item.order;

          maxOrder = parseInt(currentOrder, 10) + 1;
        } else if (elem.order === currentOrder) {
          maxOrder = parseInt(currentOrder, 10);
        }
      });
      this.story.data.content[this.stampSquareIndex].order = maxOrder;
      this.computedStamps.forEach(function (stampStatic, i, arr) {
        if (stampStatic.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          stampStatic.order = maxOrder;
          that.currentStampType = stampStatic.type;
        }
      });
      if (this.scaleResizeAvailableIndex) {
        this.eventSelectStamp = this.scaleResizeAvailableIndex;
      }
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampSquareIndex].pivot_id;
      this.$emit('current-stamp-index', this.stampSquareIndex);
      this.eventX = e.pageX;
      this.eventY = e.pageY;
    },
    move: function move(e) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].move(e, this.draggableVariables, this.stampSquareIndex, this.story, this.$refs.static, false, this.photoHeightAndWidth);
      this.computedStamps.forEach(function (stamp) {
        if (stamp.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          stamp.staticOffset = that.story.data.content[that.stampSquareIndex].staticOffset;
        }
      });
    },
    dragDestroy: function dragDestroy() {
      __WEBPACK_IMPORTED_MODULE_3__draggable_service__["a" /* default */].dragDestroy(this.draggableVariables);
      document.removeEventListener('mousemove', this.move);
      document.removeEventListener('mousemove', this.moveScaleResize);
      document.removeEventListener('mousemove', this.moveEyesLips);
      document.removeEventListener('mousemove', this.moveScaleResizeEyesLips);
    },
    initialLoad: function initialLoad(stamps) {
      var that = this;
      that.computedStamps = [];
      stamps.forEach(function (stamp, i, stampArr) {
        if (stamp.type === 'eyes' || stamp.type === 'mouth') {
          console.log('stamp ', stamp);
          var returnedEyesLips = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(stamp, that.faceLandmarks, that.imageDensity);
          stamp.initialRotationSquare = returnedEyesLips.initialRotation;
          stamp.initialScaleSquare = returnedEyesLips.initialScale;
          stamp.initialCoordinatesSquare = returnedEyesLips.initialCoordinates;
          that.addTransformationsToEyesAndLips(returnedEyesLips, stamp);

          if (returnedEyesLips) {
            stamp.scale = returnedEyesLips.scale;
            stamp.rotation = -returnedEyesLips.rotate;
            returnedEyesLips.controlScale = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].calculateScaleForControls(returnedEyesLips.scale, that.controlSideLength);
            that.computedStamps.push(returnedEyesLips);
          }
        } else if (stamp.type === 'static') {
          that.computedStamps.push(__WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].createStaticStamp(stamp, that.photoHeightAndWidth, that.controlSideLength, that.imageDensity));
        } else if (stamp.type === 'frame') {
          that.computedStamps.push(__WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].createFrameStamp(stamp, that.imageDensity));
        }
      });
      console.log('computedStamps square ', that.computedStamps);
    },
    getCoordinatesEyesLips: function getCoordinatesEyesLips(computedEyesLips) {
      return {
        x: computedEyesLips.leftTopStampPoint.x,
        y: computedEyesLips.leftTopStampPoint.y
      };
    },
    addTransformationsToEyesAndLips: function addTransformationsToEyesAndLips(eyesOrLips, storyStamp) {
      if (storyStamp.delta_offset) {
        console.log(1);
        var stampCenterX = 0;
        var stampCenterY = 0;
        var rotatePoint = __WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */].rotatePoint(storyStamp.delta_offset.x, storyStamp.delta_offset.y, stampCenterX, stampCenterY, 360 - eyesOrLips.initialRotation);
        eyesOrLips.leftTopStampPoint.x += rotatePoint.x / (4 / 3) * eyesOrLips.initialScale;
        eyesOrLips.leftTopStampPoint.y += rotatePoint.y / (4 / 3) * eyesOrLips.initialScale;
      }
      if (storyStamp.delta_scale) {
        console.log(2);
        eyesOrLips.scale *= storyStamp.delta_scale;
      }
      if (storyStamp.delta_rotation) {
        console.log(3);
        console.log(eyesOrLips.rotate);
        eyesOrLips.rotate -= storyStamp.delta_rotation;
        if (Math.abs(eyesOrLips.rotate) >= 360) eyesOrLips.rotate += 360;
        console.log(storyStamp.delta_rotation);
      }
    },
    preventDrag: function preventDrag(e) {
      e.preventDefault();
    },
    showDataForStack: function showDataForStack(event, stamp) {
      var returnedData = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].stampStackPopUp(event, stamp, this.eventSelectStamp, this.scaleResizeAvailableIndex, this.eventX, this.eventY, this.initialStampSideLength, this.computedStamps, this.currentStampType, this.story, this.stampSquareIndex);
      this.scaleResizeAvailableIndex = returnedData.scaleResizeAvailableIndex;
      this.currentStampType = returnedData.currentStampType;
      this.$emit('current-stamp-index', returnedData.stampIndex);
    }
  },
  watch: {
    startDownload: {
      handler: function handler() {
        var that = this;
        __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].createDownloadImageData(that, that.initialStampSideLength, that.computedStamps);
      }
    },
    staticStampChanges: {
      handler: function handler() {
        var that = this;
        that.story.data.content.forEach(function (storyStamp) {
          that.computedStamps.forEach(function (stamp, i, arr) {
            if (stamp.pivot_id === that.staticStampChanges.pivot_id && stamp.pivot_id === storyStamp.pivot_id) {
              stamp.scale = that.staticStampChanges.scale;
              stamp.rotate = -that.staticStampChanges.rotate;
              storyStamp.scale = that.staticStampChanges.scale;
              storyStamp.rotation = -that.staticStampChanges.rotate;
            }
          });
        });
      },

      deep: true
    },

    changedType: {
      handler: function handler() {
        if (!this.changeShape) {
          var that = this;
          var stampNotExist = true;
          var computedEyesLips = that.computedStamps;
          if (that.changedType.type === 'eyes' || that.changedType.type === 'mouth') {
            if (computedEyesLips.length > 0) {
              for (var i = computedEyesLips.length - 1; i >= 0; i -= 1) {
                if (computedEyesLips[i].pivot_id === that.changedType.pivot_id) {
                  computedEyesLips.splice(i, 1);
                  var returnedEysAndLips = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
                  if (that.story.data.content && that.stampSquareIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                    that.story.data.content[that.stampSquareIndex].coordinates = that.getCoordinatesEyesLips(returnedEysAndLips);
                    that.story.data.content[that.stampSquareIndex].initialCoordinatesSquare = that.getCoordinatesEyesLips(returnedEysAndLips);
                  }
                  computedEyesLips.push(returnedEysAndLips);
                  stampNotExist = false;
                } else if (i === computedEyesLips.length - 1 && stampNotExist) {
                  var _returnedEysAndLips = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
                  if (that.story.data.content && that.stampSquareIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                    that.story.data.content[that.stampSquareIndex].coordinates = that.getCoordinatesEyesLips(_returnedEysAndLips);
                    that.story.data.content[that.stampSquareIndex].initialCoordinatesSquare = that.getCoordinatesEyesLips(_returnedEysAndLips);
                  }
                  computedEyesLips.push(_returnedEysAndLips);
                }
              }
            } else {
              var _returnedEysAndLips2 = __WEBPACK_IMPORTED_MODULE_6__preview_services__["a" /* default */].initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
              if (that.story.data.content && that.stampSquareIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                that.story.data.content[that.stampSquareIndex].coordinates = that.getCoordinatesEyesLips(_returnedEysAndLips2);
                that.story.data.content[that.stampSquareIndex].initialCoordinatesSquare = that.getCoordinatesEyesLips(_returnedEysAndLips2);
              }
              computedEyesLips.push(_returnedEysAndLips2);
            }
          } else if (that.changedType.type === 'static' || that.changedType.type === 'frame') {
            for (var _i = computedEyesLips.length - 1; _i >= 0; _i -= 1) {
              if (computedEyesLips[_i].pivot_id && computedEyesLips[_i].pivot_id === that.changedType.pivot_id) {
                computedEyesLips.splice(_i, 1);
              }
            }
          }
          if (that.changedType.type === 'eyes') {
            that.currentStampType = 'eyes';
          } else if (that.changedType.type === 'mouth') {
            that.currentStampType = 'mouth';
          } else if (that.changedType.type === 'static') {
            that.currentStampType = 'static';
          } else if (that.changedType.type === 'frame') {
            that.currentStampType = 'frame';
          }
          that.story.data.content[that.stampSquareIndex].delta_offset = null;
          that.story.data.content[that.stampSquareIndex].delta_rotation = null;
          that.story.data.content[that.stampSquareIndex].delta_scale = null;
        }

        this.initialLoad(this.story.data.content);
      }
    },

    framePositionChanged: {
      handler: function handler() {
        this.initialLoad(this.story.data.content);
      }
    },
    refreshComponents: {
      handler: function handler() {
        this.scaleResizeAvailableIndex = null;
        this.currentStampType = null;
        this.eventSelectStamp = null;
        this.initialLoad(this.story.data.content);
        this.faceFromServer = {
          eyes: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Eyes(this.faceLandmarks.eyes[0], this.faceLandmarks.eyes[1]),
          mouth: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Mouth(this.faceLandmarks.mouth[0], this.faceLandmarks.mouth[1])
        };
        console.log('refreshComponents finished ');
      }
    },

    changeShape: {
      handler: function handler() {
        if (!this.changeShape) {
          this.photoHeightAndWidth.height = this.$refs.photo.style.height.replace('px', '');
          this.photoHeightAndWidth.width = this.$refs.photo.style.width.replace('px', '');
          this.initialLoad(this.story.data.content);
          this.faceFromServer = {
            eyes: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Eyes(this.faceLandmarks.eyes[0], this.faceLandmarks.eyes[1]),
            mouth: new __WEBPACK_IMPORTED_MODULE_4__classes__["a" /* default */].Mouth(this.faceLandmarks.mouth[0], this.faceLandmarks.mouth[1])
          };
        }
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    window.addEventListener('load', function () {
      _this6.photoHeightAndWidth.height = _this6.$refs.photo.style.height.replace('px', '');
      _this6.photoHeightAndWidth.width = _this6.$refs.photo.style.width.replace('px', '');
    });
  },
  destroy: function destroy() {
    window.removeEventListener('load', function () {});
  }
}));

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_story_editor_component__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_main_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_canvas_blob_polyfill__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_canvas_blob_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_canvas_blob_polyfill__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

window.VUEMAINSTK = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#main',
  components: {
    StoryEditor: __WEBPACK_IMPORTED_MODULE_1__js_story_editor_component__["a" /* default */]
  },
  data: {
    facePoints: {
      eyes: [{ x: 150, y: 202 }, { x: 252, y: 194 }],
      mouth: [{ x: 162, y: 302 }, { x: 237, y: 297 }]
    },
    imageSize: {
      width: 360,
      height: 640
    },
    index: null,
    pointsTrigger: true,
    storyObj: null
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes__ = __webpack_require__(14);





var previewServices = {
  counter: 1,
  createStaticStamp: function createStaticStamp(stamp, photoSize, controlSideLength, imageDensity) {
    var top = void 0;
    var left = void 0;
    if (stamp.points[0] && (stamp.points[0].x !== null || stamp.points[0].y !== null) && stamp.position) {
      for (var i = 0; i < stamp.position.length; i += 1) {
        if (stamp.position[i] === 't') {
          top = 0 - stamp.points[0].y / (4 / 3) + 'px';
        } else if (stamp.position[i] === 'b') {
          top = photoSize.height - stamp.points[0].y / (4 / 3) + 'px';
        } else if (stamp.position[i] === 'm') {
          top = photoSize.height / 2 - stamp.points[0].y / (4 / 3) + 'px';
        } else if (stamp.position[i] === 'l') {
          left = 0 - stamp.points[0].x / (4 / 3) + 'px';
        } else if (stamp.position[i] === 'r') {
          left = 0 + photoSize.width - stamp.points[0].x / (4 / 3) + 'px';
        } else if (stamp.position[i] === 'c') {
          left = photoSize.width / 2 - stamp.points[0].x / (4 / 3) + 'px';
        }
      }
    }
    var staticOffset = {
      x: left.replace('px', ''),
      y: top.replace('px', '')
    };
    var controlScale = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].calculateScaleForControls(stamp.scale, controlSideLength);
    return {
      pivot_id: stamp.pivot_id,
      url: stamp.image[imageDensity],
      order: stamp.order,
      top: top,
      left: left,
      staticOffset: staticOffset,
      type: stamp.type,
      rotate: stamp.rotation,
      scale: stamp.scale,
      controlScale: controlScale
    };
  },
  createFrameStamp: function createFrameStamp(stamp, imageDensity) {
    var top = void 0;
    var bottom = void 0;
    if (stamp.position === 't') {
      top = 0;
    } else {
      bottom = 0;
      stamp.position = 'b';
    }
    return {
      url: stamp.image[imageDensity],
      order: stamp.order,
      top: top,
      bottom: bottom,
      position: stamp.position,
      type: stamp.type,
      pivot_id: stamp.pivot_id
    };
  },
  initialLoadEyesAndLips: function initialLoadEyesAndLips(eyesOrLips, faceLandmarks, imageDensity) {
    var type = eyesOrLips.type;
    var eyesOrLipsObject = null;
    var L = 120;
    var scaleFactor = void 0;
    var rotateDegrees = void 0;
    var eyesPointsStamp = void 0;
    if (type === 'eyes') {
      eyesPointsStamp = new __WEBPACK_IMPORTED_MODULE_3__classes__["a" /* default */].Eyes({ x: L / 4, y: L / 2 }, { x: L * 3 / 4, y: L / 2 });
    } else if (type === 'mouth') {
      eyesPointsStamp = new __WEBPACK_IMPORTED_MODULE_3__classes__["a" /* default */].Eyes({ x: 0, y: L / 2 }, { x: L, y: L / 2 });
    }
    var eyesPointsPhoto = new __WEBPACK_IMPORTED_MODULE_3__classes__["a" /* default */].Eyes(faceLandmarks[type][0], faceLandmarks[type][1]);
    var photoCenterBetweenEyes = void 0;

    if (faceLandmarks.nose && type === 'eyes') {
      photoCenterBetweenEyes = {
        x: faceLandmarks.nose.x,
        y: faceLandmarks.nose.y
      };
    } else {
      photoCenterBetweenEyes = {
        x: (eyesPointsPhoto.firstEye.x + eyesPointsPhoto.secondEye.x) / 2,
        y: (eyesPointsPhoto.firstEye.y + eyesPointsPhoto.secondEye.y) / 2
      };
    }
    var stampCenterBetweenEyes = {
      x: (eyesPointsStamp.firstEye.x + eyesPointsStamp.secondEye.x) / 2,
      y: (eyesPointsStamp.firstEye.y + eyesPointsStamp.secondEye.y) / 2
    };
    rotateDegrees = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].angleBetween2Lines(eyesPointsStamp.firstEye, eyesPointsStamp.secondEye, eyesPointsPhoto.firstEye, eyesPointsPhoto.secondEye);
    scaleFactor = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].calculateScaleFactorByTwoLines(eyesPointsStamp.firstEye, eyesPointsStamp.secondEye, eyesPointsPhoto.firstEye, eyesPointsPhoto.secondEye);
    var combineStampAndPhotoPoints = {};
    combineStampAndPhotoPoints.x = photoCenterBetweenEyes.x - stampCenterBetweenEyes.x;
    combineStampAndPhotoPoints.y = photoCenterBetweenEyes.y - stampCenterBetweenEyes.y;
    var initialCoordinates = {
      x: combineStampAndPhotoPoints.x,
      y: combineStampAndPhotoPoints.y
    };
    console.log('combineStampAndPhotoPoints ', combineStampAndPhotoPoints);
    eyesOrLipsObject = {
      type: type,
      leftTopStampPoint: combineStampAndPhotoPoints,
      coordinates: combineStampAndPhotoPoints,
      pivot_id: eyesOrLips.pivot_id,
      url: eyesOrLips.image[imageDensity],
      order: eyesOrLips.order,
      scale: scaleFactor,
      rotate: -(360 - rotateDegrees),
      initialRotation: 360 - rotateDegrees,
      initialScale: scaleFactor,
      initialCoordinates: initialCoordinates
    };
    console.warn('initialScale ', scaleFactor);
    return eyesOrLipsObject;
  },
  getStampsRange: function getStampsRange(offsets, stampSize, scale) {
    var scalePixelsSize = stampSize * scale - stampSize;
    var scalePixelsSizeFromCenter = scalePixelsSize / 2;
    var stampRangeX = {
      start: parseInt(offsets.x, 10) - parseInt(scalePixelsSizeFromCenter, 10),
      end: parseInt(offsets.x, 10) + parseInt(stampSize, 10) + parseInt(scalePixelsSizeFromCenter, 10)
    };
    var stampRangeY = {
      start: parseInt(offsets.y, 10) - parseInt(scalePixelsSizeFromCenter, 10),
      end: parseInt(offsets.y, 10) + parseInt(stampSize, 10) + parseInt(scalePixelsSizeFromCenter, 10)
    };
    return {
      rangeX: stampRangeX,
      rangeY: stampRangeY
    };
  },
  scalingAndRotating: function scalingAndRotating(currentControl, stampsRangesXY) {
    var angle = void 0;
    var scale = void 0;
    var startScalePosition = {
      x: currentControl.xPoint,
      y: currentControl.yPoint
    };
    if (currentControl.selected.id === 'south-west') {
      angle = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.maximumValue, y: stampsRangesXY.minimumValue });
      scale = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.maximumValue, y: stampsRangesXY.minimumValue });
    } else if (currentControl.selected.id === 'south-east') {
      angle = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.minimumValue, y: stampsRangesXY.minimumValue });
      scale = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.minimumValue, y: stampsRangesXY.minimumValue });
    } else if (currentControl.selected.id === 'north-west') {
      angle = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.maximumValue, y: stampsRangesXY.maximumValue });
      scale = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.middleValue, y: stampsRangesXY.middleValue }, {
        x: stampsRangesXY.maximumValue,
        y: stampsRangesXY.maximumValue
      });
    } else if (currentControl.selected.id === 'north-east') {
      angle = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.minimumValue, y: stampsRangesXY.maximumValue });
      scale = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, { x: stampsRangesXY.minimumValue, y: stampsRangesXY.maximumValue });
    }
    return {
      angle: angle,
      scale: scale
    };
  },
  stampStackPopUp: function stampStackPopUp(event, stamp, eventSelectStamp, scaleResizeAvailableIndex, eventX, eventY, initialStampSideLength, computedStamps, currentStampType, story, stampIndex) {
    var that = this;
    var offsetConst = 1;
    if (eventSelectStamp === scaleResizeAvailableIndex) {
      if (event.pageX <= eventX + offsetConst && event.pageX >= eventX - offsetConst && event.pageY <= eventY + offsetConst && event.pageY >= eventY - offsetConst) {
        var mouseOffsetXWithScale = event.offsetX * stamp.scale;
        var mouseOffsetYWithScale = event.offsetY * stamp.scale;
        var stampOffsetX = event.target.offsetLeft - (initialStampSideLength * stamp.scale - initialStampSideLength) / 2;
        var stampOffsetY = event.target.offsetTop - (initialStampSideLength * stamp.scale - initialStampSideLength) / 2;
        var absoluteClickXWithScale = stampOffsetX + mouseOffsetXWithScale;
        var absoluteClickYWithScale = stampOffsetY + mouseOffsetYWithScale;
        var currentOrder = null;
        var lowerOrder = null;
        var lowerOrderElem = void 0;
        var absoluteStampCenterWithOffsets = that.stampCenter(initialStampSideLength, stamp);
        console.log('stamp ', stamp);
        var rotatedClickInitial = void 0;
        var initialRotatedClickWithOffsets = void 0;

        if (stamp.type === 'static') {
          rotatedClickInitial = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].rotatePoint(absoluteClickXWithScale, absoluteClickYWithScale, absoluteStampCenterWithOffsets.x, absoluteStampCenterWithOffsets.y, 360 - stamp.rotate);
          initialRotatedClickWithOffsets = {
            x: rotatedClickInitial.x,
            y: rotatedClickInitial.y
          };
        } else if (stamp.type === 'eyes' || stamp.type === 'mouth') {
          rotatedClickInitial = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].rotatePoint(absoluteClickXWithScale, absoluteClickYWithScale, absoluteStampCenterWithOffsets.x, absoluteStampCenterWithOffsets.y, 360 + stamp.rotate);
          initialRotatedClickWithOffsets = {
            x: rotatedClickInitial.x,
            y: rotatedClickInitial.y
          };
          console.error('eyes');
        }
        console.warn(initialRotatedClickWithOffsets.x);
        console.warn(initialRotatedClickWithOffsets.y);
        computedStamps.forEach(function (compStamp) {
          var range = void 0;
          if (compStamp.type === 'static') {
            range = that.getStampsRange(compStamp.staticOffset, initialStampSideLength, compStamp.scale);
          } else if (compStamp.type === 'eyes' || compStamp.type === 'mouth') {
            range = that.getStampsRange(compStamp.leftTopStampPoint, initialStampSideLength, compStamp.scale);
          }
          var currentStampCenterWithOffsets = that.stampCenter(initialStampSideLength, compStamp);

          var rotatedClick = __WEBPACK_IMPORTED_MODULE_2__geometry__["a" /* default */].rotatePoint(initialRotatedClickWithOffsets.x, initialRotatedClickWithOffsets.y, currentStampCenterWithOffsets.x, currentStampCenterWithOffsets.y, compStamp.rotate);
          var rotatedClickWithStampOffsets = {
            x: rotatedClick.x,
            y: rotatedClick.y
          };
          if (range && range.rangeX.start <= rotatedClickWithStampOffsets.x && rotatedClickWithStampOffsets.x <= range.rangeX.end && range.rangeY.start <= rotatedClickWithStampOffsets.y && rotatedClickWithStampOffsets.y <= range.rangeY.end) {
            if (currentOrder === null) {
              currentOrder = stamp.order;
            }
            if (stamp !== compStamp && currentOrder > compStamp.order) {
              currentOrder = compStamp.order;
              lowerOrder = parseInt(currentOrder, 10);
              lowerOrderElem = compStamp;
            } else if (compStamp.order === currentOrder) {
              lowerOrder = parseInt(currentOrder, 10);
              lowerOrderElem = compStamp;
            }
            console.log(lowerOrderElem);
          }
        });
        if (lowerOrderElem) {
          lowerOrderElem.order = stamp.order + 1;
          scaleResizeAvailableIndex = lowerOrderElem.pivot_id;
          if (lowerOrderElem.type === 'eyes') {
            currentStampType = 'eyes';
          } else if (lowerOrderElem.type === 'mouth') {
            currentStampType = 'mouth';
          } else if (lowerOrderElem.type === 'static') {
            currentStampType = 'static';
          } else if (lowerOrderElem.type === 'frame') {
            currentStampType = 'frame';
          }
          story.data.content.forEach(function (item, i) {
            if (item.pivot_id === lowerOrderElem.pivot_id) {
              stampIndex = i;
            }
          });
          story.data.content[stampIndex].order = lowerOrderElem.order;
        }
      }
    }
    return {
      stampIndex: stampIndex,
      scaleResizeAvailableIndex: scaleResizeAvailableIndex,
      currentStampType: currentStampType
    };
  },
  stampCenter: function stampCenter(stampSideLength, stamp) {
    var currentStampCenter = stampSideLength * stamp.scale / 2;
    var currentStampOffsetX = void 0;
    var currentStampOffsetY = void 0;
    if (stamp.type === 'static') {
      currentStampOffsetX = stamp.staticOffset.x;
      currentStampOffsetY = stamp.staticOffset.y;
    } else if (stamp.type === 'eyes' || stamp.type === 'mouth') {
      currentStampOffsetX = stamp.leftTopStampPoint.x;
      currentStampOffsetY = stamp.leftTopStampPoint.y;
    }
    var stampOffsetWithScaleX = currentStampOffsetX - (stampSideLength * stamp.scale - stampSideLength) / 2;
    var stampOffsetWithScaleY = currentStampOffsetY - (stampSideLength * stamp.scale - stampSideLength) / 2;
    return {
      x: stampOffsetWithScaleX + currentStampCenter,
      y: stampOffsetWithScaleY + currentStampCenter
    };
  },
  sendPhotoToBackend: function sendPhotoToBackend(http, host, storyId, formData) {
    return http.post(host + '/cp/stories/' + storyId + '/content', formData, {
      headers: {
        "Content-Type": 'multipart/form-data'
      }
    });
  },
  highlightDefaultStamp: function highlightDefaultStamp(story, currentStamp) {
    var stampIndex = null;
    var highLightIndex = null;
    story.data.content.forEach(function (item, i) {
      if (item.pivot_id === currentStamp.pivot_id) {
        stampIndex = i;
        highLightIndex = item.pivot_id;
      }
    });
    return { stampIndex: stampIndex, highLightIndex: highLightIndex };
  },
  createDownloadImageData: function createDownloadImageData(that, initialStampSideLength, computedStamps) {
    that.$emit('download-data', {
      size: initialStampSideLength,
      stamps: computedStamps
    });
  },
  createCanvasStory: function createCanvasStory(canvas, photoUrl, photoSize, stampSize, stamps, link) {
    var that = this;
    var promiseArray = [];
    var context = canvas.getContext('2d');
    canvas.width = photoSize.width;
    canvas.height = photoSize.height;
    var canvasStamps = stamps.map(function (stamp) {
      console.log('stamp ', stamp);
      var scaledSize = void 0;
      var scaleDiff = void 0;
      var margins = void 0;
      var rotate = void 0;
      var stampUrl = void 0;
      var stampOrder = void 0;
      if (stamp.type === 'eyes' || stamp.type === 'mouth' && stamp.leftTopStampPoint) {
        console.log('leftTopStampPoint ', stamp.leftTopStampPoint.x);
        scaledSize = stampSize * stamp.scale;
        scaleDiff = (scaledSize - stampSize) / 2;
        margins = {
          x: stamp.leftTopStampPoint.x - scaleDiff,
          y: stamp.leftTopStampPoint.y - scaleDiff
        };
        rotate = stamp.rotate;
        stampUrl = stamp.url;
        stampOrder = stamp.order;
      } else if (stamp.staticOffset && stamp.type === 'static') {
        scaledSize = stampSize * stamp.scale;
        scaleDiff = (scaledSize - stampSize) / 2;
        console.log('staticOffset ', stamp.staticOffset.x);
        margins = {
          x: stamp.staticOffset.x - scaleDiff,
          y: stamp.staticOffset.y - scaleDiff
        };
        rotate = stamp.rotate;
        stampUrl = stamp.url;
        stampOrder = stamp.order;
      } else if (stamp.type === 'frame') {
        scaledSize = photoSize.width;
        scaleDiff = 0;
        rotate = 0;
        stampUrl = stamp.url;
        stampOrder = 0;
        if (stamp.position === 'b') {
          margins = {
            x: 0,
            y: photoSize.height - 270
          };
        } else if (stamp.position === 't') {
          margins = {
            x: 0,
            y: 0
          };
        }
      }
      return {
        scaledSize: scaledSize,
        scaleDiff: scaleDiff,
        margins: margins,
        stampUrl: stampUrl,
        stampOrder: stampOrder,
        rotate: rotate,
        type: stamp.type
      };
    });
    canvasStamps.sort(function (a, b) {
      return a.stampOrder - b.stampOrder;
    });
    console.log('canvasStamps ', canvasStamps);

    var background = new Image(photoSize.width, photoSize.height);
    background.src = photoUrl;
    context.drawImage(background, 0, 0);
    canvasStamps.forEach(function (item) {
      var img = new Image();
      img.src = item.stampUrl;
      context.save();
      context.translate(item.margins.x + item.scaledSize / 2, item.margins.y + item.scaledSize / 2);
      if (item.type === 'static') {
        context.rotate(-item.rotate * Math.PI / 180);
      } else {
        context.rotate(item.rotate * Math.PI / 180);
      }
      context.translate(-(item.margins.x + item.scaledSize / 2), -(item.margins.y + item.scaledSize / 2));
      context.drawImage(img, item.margins.x, item.margins.y, item.scaledSize, item.scaledSize);
      context.restore();
      promiseArray.push(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        img.onload = function () {
          resolve();
        };
        setTimeout(function () {
          reject();
        }, 4000);
      }));
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function (success) {
      console.log(__WEBPACK_IMPORTED_MODULE_1_file_saver___default.a);
      canvas.toBlob(function (blob) {
        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(blob, "Stickerpipe story.jpeg");
      });
    }, function (error) {
      console.log('error ', error);
    });
  },
  loaderService: function loaderService(loader, loaderStatus) {
    if (loaderStatus) {
      loader.style.display = 'block';
    } else {
      loader.style.display = 'none';
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (previewServices);

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports = "<div class=\"droppable-zone\">\n    <div ref=\"dropzone\">\n        <slot></slot>\n    </div>\n</div>\n";

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"troublemaker-nav container\" v-if=\"usage !== 'landing'\">\n        <div class=\"row\">\n            <div class=\"col-sm-4 position-static\">\n                <ul class=\"nav nav-pills\">\n                    <!-- todo: add discard later -->\n                    <!--<li><a href=\"#\">Discard</a></li>-->\n                </ul>\n            </div>\n            <div class=\"col-sm-4 position-static trouble-title\">Troublemaker</div>\n            <div class=\"col-sm-4 position-static\">\n                <ul class=\"nav nav-pills float-right\">\n                    <li><a @click=\"demoInMessenger\" target=\"_blank\" :href=\"demoUrl + storyId\">Demo in messenger</a></li>\n                    <li><a href=\"#\" @click=\"updateStampHttp\">Save</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <div class=\"story-editor-wrapper container\">\n        <div class=\"row\">\n            <div class=\"col-md-3\">\n                <div class=\"gray-panel-padding form-group\">\n                    <div class=\"dropdown\">\n                        <button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"dropdownPacks\"\n                                data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"\n                                @click=\"cleanPacksAndStampsLists; ; cancelStampSelecting()\">\n                            Add new stamp <span class=\"caret\"></span>\n                        </button>\n                        <ul class=\"dropdown-menu scrollable-dropdown-300\" aria-labelledby=\"dropdownPacks\"\n                            @click=\"stopClosingLists($event)\" v-if=\"!stampsList\">\n                            <li class=\"search-packs\">\n                                <input type=\"text\" class=\"form-control\" v-model=\"packsQuery\" ref=\"searchInput\"\n                                       @click=\"stopClosingLists($event); cancelStampSelecting()\"\n                                       @mousedown=\"showPackList\"\n                                       placeholder=\"Add new stamp\" id=\"addNewStamp\">\n                            </li>\n                            <li v-for=\"pack in filteredPacks\" @click=\"getStampsFromServer(pack.id)\">\n                                <a>\n                                    {{pack.title}}\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"stamp-list\" v-if=\"stampsList\" id=\"stamp-list\" @click=\"stopClosingLists($event)\">\n                        <div v-for=\"stamp in stampsList\"\n                             @click=\"addStampToStoryArray(stamp.content_id, storyId)\">\n                            <img :src=\"stamp.image.xxhdpi\" alt=\"\">\n                        </div>\n                    </div>\n                </div>\n                <div class=\"story-editor-dropezone form-group\">\n                    <dropzone :story=\"parsedStory\"\n                              v-on:updated-story=\"dropZoneUpdatedStory\"\n                              :commonPack=\"commonPack\"\n                              v-on:update-common=\"updateCommonPack\"\n                              :host=\"host\"\n                              :story-id=\"storyId\"\n                              v-on:update-loader=\"updateLoader\">\n                        <div class=\"dropzone-text\">\n                            <span>Drag image file here</span></br>\n                            <i class=\"fa fa-upload\" aria-hidden=\"true\"></i>\n                        </div>\n                    </dropzone>\n                    <div class=\"common-pack-list gray-panel-padding\" v-if=\"commonPack.length > 0\">\n                        <div class=\"common-pack-item\" v-for=\"stamp in commonPack\"\n                             @click=\"addStampToStoryArray(stamp.content_id, storyId)\">\n                            <img :src=\"stamp.image.xxhdpi\" alt=\"\">\n                            <div class=\"common-pack-delete\" @click=\"deleteCommonStamp($event, stamp.content_id, stamp)\"></div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"gray-panel-padding form-group\" v-if=\"stampIndex\">\n                    <visual-stamps-list class=\"visual-stamp-list\" :host-url=\"host\"\n                                        :storyId=\"storyId\"\n                                        v-on:delete=\"deleteAndReload\"\n                                        v-on:story-update=\"getStampObj\" :story=\"parsedStory\"\n                                        v-on:type-trigger=\"typeTrigger\" :stamp-index=\"stampIndex\"\n                                        v-on:frame-position=\"framePositionChanged\"></visual-stamps-list>\n                </div>\n                <div>\n                    <canvas style=\"display: none;\" ref=\"canvasTest\"></canvas>\n                </div>\n            </div>\n            <div class=\"col-md-6 position-static no-padding\">\n                <div class=\"preview-and-change\" v-bind:class=\"{'background-transparent': photoType == 'square'}\">\n                    <visual-preview v-show=\"!square\"\n                                    :story='parsedStory'\n                                    :change-shape=\"changeShape\"\n                                    :photo-url=\"currentPhoto.vertical.url\"\n                                    :size=\"size\"\n                                    :face-landmarks=\"currentPhoto.vertical.faceLandmarks\"\n                                    :changed-type=\"changedType\"\n                                    :photo-type-trigger=\"!square\"\n                                    :photo-type=\"'vertical'\"\n                                    :static-stamp-changes=\"staticStampChanges\"\n                                    :refresh-components=\"refreshComponents\"\n                                    :frame-position-changed=\"framePositionTrigger\"\n                                    :start-download=\"verticalLoadStart\"\n                                    :usage=\"usage\"\n                                    v-on:current-stamp-index=\"setStampIndex\"\n                                    v-on:static-stamp-changes=\"getStaticStampChanges\"\n                                    v-on:download-data=\"generateSavedCanvas\"></visual-preview>\n                    <!--photo-url=\"https://stickerpipe.com/stories/david_square.jpg\"-->\n                    <!--:face-landmarks=\"{eyes: [{x: 199, y: 201}, {x: 311, y: 202}], mouth: [{x: 214, y: 325}, {x: 300, y: 327}]}\"-->\n\n                    <visual-preview-square v-show=\"square\"\n                                           :story='parsedStory'\n                                           :change-shape=\"changeShape\"\n                                           :photo-url=\"currentPhoto.square.url\"\n                                           :size=\"squareSize\"\n                                           :face-landmarks=\"currentPhoto.square.faceLandmarks\"\n                                           :changed-type=\"changedType\"\n                                           :photo-type-trigger=\"square\"\n                                           :photo-type=\"'square'\"\n                                           :static-stamp-changes=\"staticStampChanges\"\n                                           :refresh-components=\"refreshComponents\"\n                                           :frame-position-changed=\"framePositionTrigger\"\n                                           :start-download=\"squareLoadStart\"\n                                           v-on:current-stamp-index=\"setStampIndex\"\n                                           v-on:static-stamp-changes=\"getStaticStampChanges\"\n                                           v-on:download-data=\"generateSavedCanvas\"></visual-preview-square>\n                </div>\n            </div>\n            <div class=\"col-md-3\">\n                <div v-if=\"usage === 'landing'\">\n                    <a :href=\"demoUrl + storyId\" target=\"_blank\"><button class=\"btn btn-primary demo-messenger\"  @click=\"demoInMessenger\">Demo in<span\n                            class=\"messenger-icon\">Messenger</span></button></a>\n                </div>\n                <div class=\"save-change-story gray-panel-padding\">\n                    <div class=\"form-group\">\n                        <div class=\"btn-group\">\n                            <button type=\"button\" class=\"btn btn-default no-outline\" :disabled=\"!square\"\n                                    v-bind:class=\"{ active: !square }\"\n                                    @click=\"changeStoryShape\">Portrait\n                            </button>\n                            <button type=\"button\" class=\"btn btn-default no-outline\" :disabled=\"square\"\n                                    v-bind:class=\"{ active: square }\"\n                                    @click=\"changeStoryShape\">Square\n                            </button>\n                        </div>\n                    </div>\n                    <div class=\"btn-group\">\n                        <button type=\"button\" class=\"btn btn-default no-outline\"\n                                @click=\"prevPhoto\">\n                            <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\n                        </button>\n                        <button type=\"button\" class=\"btn btn-default no-outline\"\n                                @click=\"nextPhoto\">\n                            <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n                        </button>\n                    </div>\n                    <div class=\"margin-top-10\">\n                        <button @click=\"beginSave\" class=\"btn btn-default\">Download your story</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"loader\"></div>\n    </div>\n</div>\n";

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

module.exports = "<div class=\"stamp-list-wrapper\" v-if=\"currentStamp\">\n    <div class=\"current-stamp\">\n        <div>\n            <h5>Stamp setup</h5>\n        </div>\n        <div>\n            <select class=\"form-control\" v-model=\"currentStamp.type\"\n                    v-on:change=\"typeChanges(story, stampIndex, currentStamp.type)\">\n                <option v-for=\"type in stampTypes\" v-bind:value=\"type\">{{type}}</option>\n            </select>\n            <div v-if=\"currentStamp.type == 'frame'\" class=\"frame-buttons\">\n                <div class=\"btn-group margin-5-0\">\n                    <label for=\"top\" class=\"btn btn-default no-outline\" v-bind:class=\"{'active': currentStamp.position === 't'}\">Top</label>\n                    <label for=\"bottom\" class=\"btn btn-default no-outline\" v-bind:class=\"{'active': currentStamp.position === 'b'}\">Bottom</label>\n                </div>\n                <input v-model=\"currentStamp.position\" @change=\"emitFramePosition(currentStamp.position)\" id=\"top\" type=\"radio\" name=\"framePosition\" v-bind:value=\"'t'\">\n                <input v-model=\"currentStamp.position\" @change=\"emitFramePosition(currentStamp.position)\" id=\"bottom\" type=\"radio\" name=\"framePosition\" v-bind:value=\"'b'\">\n            </div>\n        </div>\n\n        <div>\n            <div class=\"col-sm-6 text-left margin-5-0\">\n                Rotation\n            </div>\n            <div class=\"col-sm-6 text-left margin-5-0\">\n                {{currentStamp.rotation}}&#176;\n            </div>\n        </div>\n        <div>\n            <div class=\"col-sm-6 text-left margin-5-0\">\n                Scale\n            </div>\n            <div class=\"col-sm-6 text-left margin-5-0\">\n                {{currentScale}}\n            </div>\n        </div>\n        <div class=\"btn btn-default delete\" @click=\"deleteStamp(currentStamp.pivot_id, currentStamp)\">Delete</div>\n    </div>\n</div>";

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"story-container\" ref=\"container\" v-bind:style=\"{height: size.height + 'px', width: size.width + 'px'}\">\n        <div v-for=\"(stamp, index) in computedStamps\" v-if=\"stamp.type === 'eyes' || stamp.type === 'mouth'\">\n            <div ref=\"stamp\" class=\"stamp\" v-bind:class=\"{'static-active': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                 @mousedown=\"dragStartEyesLips($event, 0, stamp, index)\"\n                 v-bind:style=\"{ backgroundImage: 'url(' + stamp.url + ')', backgroundSize: 'contain',\n            backgroundRepeat: 'no-repeat', top: stamp.leftTopStampPoint.y + 'px', left: stamp.leftTopStampPoint.x + 'px',\n            zIndex: stamp.order,\n            transform: 'scale('+ stamp.scale + ')'+' rotate('+ stamp.rotate + 'deg)'}\"\n                 @click=\"showDataForStack($event, stamp)\">\n                <!--background: repeating-linear-gradient(-->\n                <!--45deg,-->\n                <!--#606dbc,-->\n                <!--#606dbc 10px,-->\n                <!--#465298 10px,-->\n                <!--#465298 20px-->\n                <!--);-->\n                <!--<div :style=\"{background: 'repeating-linear-gradient(90deg,#000000,#000000 7px,transparent 7px,transparent 14px)', position: 'absolute', top: '-1px', height: '2px', width: 100 / stamp.controlScale +'%'}\"></div>-->\n                <!--<div style=\"background: red; position: absolute; bottom: -2px; height: 2px; width: calc(100% + 2px);\"></div>-->\n                <!--<div style=\"background: red; position: absolute; left: -2px; width: 2px; height: calc(100% + 2px);\"></div>-->\n                <!--<div style=\"background: red; position: absolute; right: -2px; width: 2px; height: calc(100% + 2px);\"></div>-->\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"south-west\" id=\"south-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"south-west\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"south-east\" id=\"south-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"south-east\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"north-east\" id=\"north-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"north-east\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"north-west\" id=\"north-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"north-west\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n            </div>\n        </div>\n\n        <div class=\"frame\" v-for=\"(frame, index) in computedStamps\" v-if=\"frame.type === 'frame'\"\n             v-bind:class=\"{'static-active': scaleResizeAvailableIndex == frame.pivot_id}\"\n             v-on:click=\"selectFrameStamp(index, frame)\"\n             v-bind:style=\"{backgroundImage: 'url(' + frame.url + ')', backgroundSize: 'contain',\n             width: photoHeightAndWidth.width + 'px', height: photoHeightAndWidth.width + 'px',\n             backgroundRepeat: 'no-repeat',top: frame.top, bottom: frame.bottom}\">\n        </div>\n\n        <div ref=\"static-container\" v-for=\"(static, index) in computedStamps\" v-if=\"static.type === 'static'\">\n            <div v-bind:class=\"{'static-active': scaleResizeAvailableIndex == static.pivot_id}\" class=\"static\" ref=\"static\"\n                 @mousedown=\"dragStart($event, 0, static, index)\" v-bind:style=\"{ backgroundImage: 'url(' + static.url + ')', backgroundSize: 'contain',\n             backgroundRepeat: 'no-repeat', left: static.left, top: static.top,\n             zIndex: static.order,\n             transform: 'scale('+ static.scale + ')'+' rotate(-'+ static.rotate + 'deg)'}\"\n            @click=\"showDataForStack($event, static)\">\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"south-west\" id=\"south-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"south-west\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"south-east\" id=\"south-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"south-east\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"north-east\" id=\"north-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"north-east\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"north-west\" id=\"north-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"north-west\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <!--<div style=\"width: 100%; height: 100%; background-color: rgba(235,235,235,0.19); border: 1px solid red\"-->\n                     <!--v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\">-->\n\n                <!--</div>-->\n            </div>\n        </div>\n        <div ref=\"eyes\" v-if=\"currentStampType == 'eyes'\">\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.eyes.firstEye.x - crossSize / 2 + 'px', top: faceFromServer.eyes.firstEye.y - crossSize / 2 + 'px'}\"></div>\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.eyes.secondEye.x - crossSize / 2 + 'px', top: faceFromServer.eyes.secondEye.y - crossSize / 2 + 'px'}\"></div>\n        </div>\n        <div ref=\"mouth\" v-if=\"currentStampType == 'mouth'\">\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.mouth.leftMouthCorner.x - crossSize / 2 + 'px', top: faceFromServer.mouth.leftMouthCorner.y - crossSize / 2 + 'px'}\"></div>\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.mouth.rightMouthCorner.x - crossSize / 2 + 'px', top: faceFromServer.mouth.rightMouthCorner.y - crossSize / 2 + 'px'}\"></div>\n        </div>\n        <img @dragstart=\"preventDrag\" class=\"user-select-none\" v-bind:style=\"{height: size.height + 'px', width: size.width + 'px'}\" ref=\"photo\" v-on:click=\"clickOnImage\" :src='photoUrl' alt=\"\">\n    </div>\n</div>";

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"story-container\" ref=\"container\" v-bind:style=\"{height: size.height + 'px', width: size.width + 'px'}\">\n        <div v-for=\"(stamp, index) in computedStamps\" v-if=\"stamp.type === 'eyes' || stamp.type === 'mouth'\">\n            <div ref=\"stamp\" class=\"stamp\" v-bind:class=\"{'static-active': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                 @mousedown=\"dragStartEyesLips($event, 0, stamp, index)\"\n                 v-bind:style=\"{ backgroundImage: 'url(' + stamp.url + ')', backgroundSize: 'contain',\n            backgroundRepeat: 'no-repeat', top: stamp.leftTopStampPoint.y + 'px', left: stamp.leftTopStampPoint.x + 'px',\n            zIndex: stamp.order,\n            transform: 'scale('+ stamp.scale + ')'+' rotate('+ stamp.rotate + 'deg)'}\"\n                 @click=\"showDataForStack($event, stamp)\">\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"south-west\" id=\"south-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"south-west\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"south-east\" id=\"south-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"south-east\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"north-east\" id=\"north-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"north-east\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResizeEyesLips($event, index, stamp)\" ref=\"north-west\" id=\"north-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == stamp.pivot_id}\"\n                     class=\"north-west\" v-bind:style=\"{transform: 'scale('+ stamp.controlScale + ')'}\"></div>\n            </div>\n        </div>\n\n        <div class=\"frame\" v-for=\"(frame, index) in computedStamps\" v-if=\"frame.type === 'frame'\"\n             v-bind:class=\"{'static-active': scaleResizeAvailableIndex == frame.pivot_id}\"\n             v-on:click=\"selectFrameStamp(index, frame)\"\n             v-bind:style=\"{backgroundImage: 'url(' + frame.url + ')', backgroundSize: 'contain',\n             width: photoHeightAndWidth.width + 'px', height: photoHeightAndWidth.width + 'px',\n             backgroundRepeat: 'no-repeat',top: frame.top, bottom: frame.bottom}\">\n        </div>\n\n        <div ref=\"static-container\" v-for=\"(static, index) in computedStamps\" v-if=\"static.type === 'static'\">\n            <div v-bind:class=\"{'static-active': scaleResizeAvailableIndex == static.pivot_id}\" class=\"static\" ref=\"static\"\n                 @mousedown=\"dragStart($event, 0, static, index)\" v-bind:style=\"{ backgroundImage: 'url(' + static.url + ')', backgroundSize: 'contain',\n             backgroundRepeat: 'no-repeat', left: static.left, top: static.top,\n             zIndex: static.order,\n             transform: 'scale('+ static.scale + ')'+' rotate(-'+ static.rotate + 'deg)'}\"\n                 @click=\"showDataForStack($event, static)\">\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"south-west\" id=\"south-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"south-west\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"south-east\" id=\"south-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"south-east\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"north-east\" id=\"north-east\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"north-east\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n                <div @mousedown=\"startScaleResize($event, index, static)\" ref=\"north-west\" id=\"north-west\"\n                     v-bind:class=\"{'resize-scale-points': scaleResizeAvailableIndex == static.pivot_id}\"\n                     class=\"north-west\" v-bind:style=\"{transform: 'scale('+ static.controlScale + ')'}\"></div>\n            </div>\n        </div>\n        <div ref=\"eyes\" v-if=\"currentStampType == 'eyes'\">\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.eyes.firstEye.x - crossSize / 2 + 'px', top: faceFromServer.eyes.firstEye.y - crossSize / 2 + 'px'}\"></div>\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.eyes.secondEye.x - crossSize / 2 + 'px', top: faceFromServer.eyes.secondEye.y - crossSize / 2 + 'px'}\"></div>\n        </div>\n        <div ref=\"mouth\" v-if=\"currentStampType == 'mouth'\">\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.mouth.leftMouthCorner.x - crossSize / 2 + 'px', top: faceFromServer.mouth.leftMouthCorner.y - crossSize / 2 + 'px'}\"></div>\n            <div class=\"cross\" v-bind:style=\"{height: crossSize + 'px', width: crossSize + 'px', left: faceFromServer.mouth.rightMouthCorner.x - crossSize / 2 + 'px', top: faceFromServer.mouth.rightMouthCorner.y - crossSize / 2 + 'px'}\"></div>\n        </div>\n        <img @dragstart=\"preventDrag\" class=\"user-select-none\" v-bind:style=\"{height: size.height + 'px', width: size.width + 'px'}\" ref=\"photo\" v-on:click=\"clickOnImage\" :src='photoUrl' alt=\"\">\n    </div>\n</div>";

/***/ })

},[48]);


// WEBPACK FOOTER //
// static/js/app.85afe885b26e57bb50bf.js